(function (global) {
  'use strict';

  var ROOT_SELECTOR = '[data-qy-garden]';
  var VIEWER_SELECTOR = '[data-qiyuan-3d-root]';
  var VIEWER_SCRIPT_SELECTOR = 'script[data-qiyuan-shared-viewer]';
  var HALLS = ['guanyin', 'dizang', 'caishen', 'pet'];
  var HALL_CODE_BY_SCENE = {
    guanyin: 'guanyin',
    dizang: 'dizang',
    caishen: 'caishen',
    pet: 'pet_memorial',
  };
  var DURATION_CODE_BY_SELECTION = {
    '1-day': '1d',
    '7-days': '7d',
    '49-days': '49d',
    '100-days': '100d',
    '1-year': '1y',
  };
  var ACTIONS = ['lamp', 'incense', 'message'];
  var DURATIONS = ['1-day', '7-days', '49-days', '100-days', '1-year'];
  var LOADER_DELAY = 250;
  var MODEL_REVEAL_DURATION = 350;
  var PET_ENTRY_TRANSITION_DURATION = 720;
  var PET_ENTRY_REVEAL_DURATION = 260;
  var PET_LAMP_IGNITION_DELAY = 180;
  var PET_LAMP_REVEAL_DELAY = 1500;
  var LAMP_ROTATION_INTERVAL = 8000;
  var LAMP_TRANSITION_DURATION = 600;
  var GARDEN_PREVIEW_LIMIT = 2;
  var GARDEN_PREVIEW_ROTATION_INTERVAL = 12000;
  var LAMP_ASSET_URL = 'qiyuan-lotus-lamp-optimized.webp';
  var GARDEN_SOUND_TARGET_VOLUME = 0.13;
  var GARDEN_SOUND_FADE_IN_DURATION = 1350;
  var GARDEN_SOUND_FADE_OUT_DURATION = 1200;
  var GARDEN_SOUND_ENABLED_KEY = 'qiyuanGardenSoundEnabled';
  var GARDEN_SOUND_TIME_KEY = 'qiyuanGardenSoundCurrentTime';
  var LOADER_COPY = {
    garden: {
      sceneTitle: 'Main Garden',
      sceneTitleZh: '主庭院',
      title: 'Opening the Main Garden',
      titleZh: '庭院正在徐徐展开',
      subtitle: 'A quiet space for remembrance and heartfelt wishes',
    },
    guanyin: {
      sceneTitle: 'Guanyin Hall',
      sceneTitleZh: '观音殿',
      title: 'Opening Guanyin Hall',
      titleZh: '观音殿正在徐徐展开',
      subtitle: 'A quiet space for wishes and reflection',
    },
    dizang: {
      sceneTitle: 'Kṣitigarbha Hall',
      sceneTitleZh: '地藏殿',
      title: 'Opening Kṣitigarbha Hall',
      titleZh: '地藏殿正在徐徐展开',
      subtitle: 'A quiet space for remembrance and reflection',
    },
    caishen: {
      sceneTitle: 'Caishen Hall',
      sceneTitleZh: '财神殿',
      title: 'Opening Caishen Hall',
      titleZh: '财神殿正在徐徐展开',
      subtitle: 'A quiet space for hopes and intentions',
    },
    pet: {
      sceneTitle: 'Pet Memorial Garden',
      sceneTitleZh: '宠物纪念园',
      title: 'Opening the Pet Memorial Garden',
      titleZh: '宠物纪念园正在徐徐展开',
      subtitle: 'A quiet space for love and remembrance',
    },
  };
  var SOURCE = 'homepage garden';
  var controllers = typeof WeakMap === 'function' ? new WeakMap() : null;
  var parkedViewers = new Map();
  var viewerLoader = {
    promise: null,
    url: '',
  };

  if (global.QiyuanEasternMemorialGarden && global.QiyuanEasternMemorialGarden.version) {
    if (global.document && global.QiyuanEasternMemorialGarden.init) {
      global.QiyuanEasternMemorialGarden.init(global.document);
    }
    return;
  }

  function toArray(value) {
    return Array.prototype.slice.call(value || []);
  }

  function matches(element, selector) {
    return Boolean(element && element.matches && element.matches(selector));
  }

  function queryAll(scope, selector) {
    return scope && scope.querySelectorAll ? toArray(scope.querySelectorAll(selector)) : [];
  }

  function rootsWithin(scope) {
    var roots = [];

    if (matches(scope, ROOT_SELECTOR)) roots.push(scope);
    queryAll(scope, ROOT_SELECTOR).forEach(function (root) {
      if (roots.indexOf(root) === -1) roots.push(root);
    });

    return roots;
  }

  function isHall(value) {
    return HALLS.indexOf(value) !== -1;
  }

  function isDuration(value) {
    return DURATIONS.indexOf(value) !== -1;
  }

  function isAction(value) {
    return ACTIONS.indexOf(value) !== -1;
  }

  function isPreviewOnlyScene(scene) {
    return false;
  }

  function hallCodeForScene(scene) {
    return HALL_CODE_BY_SCENE[scene] || HALL_CODE_BY_SCENE.guanyin;
  }

  function durationCodeForSelection(duration) {
    return DURATION_CODE_BY_SELECTION[duration] || '';
  }

  function durationSeconds(duration) {
    return {
      '1-day': 86400,
      '7-days': 604800,
      '49-days': 4233600,
      '100-days': 8640000,
      '1-year': 31536000,
    }[duration] || 86400;
  }

  function lampCapacityForWidth(width) {
    if (width >= 1024) return 4;
    if (width >= 641) return 2;
    return 1;
  }

  function groupLampLights(lights, capacity) {
    var groups = [];
    for (var index = 0; index < lights.length; index += capacity) {
      groups.push(lights.slice(index, index + capacity));
    }
    return groups;
  }

  function activePublicLights(lights, now) {
    var currentTime = Number.isFinite(now) ? now : Date.now();
    return (Array.isArray(lights) ? lights : [])
      .filter(function (light) {
        return light && new Date(light.expires_at).getTime() > currentTime;
      })
      .sort(function (left, right) {
        var difference = new Date(right.starts_at).getTime() - new Date(left.starts_at).getTime();
        return difference || cleanString(right.public_id).localeCompare(cleanString(left.public_id));
      });
  }

  function publicLampName(light) {
    return cleanString(light && light.display_name) || 'Anonymous';
  }

  function gardenPreviewLights(lights, groupIndex) {
    var groups = groupLampLights(Array.isArray(lights) ? lights : [], GARDEN_PREVIEW_LIMIT);
    var index = Math.max(0, Number(groupIndex) || 0);
    return groups.length ? groups[index % groups.length] : [];
  }

  function randomProxyNonce() {
    var bytes = new Uint8Array(18);

    if (!global.crypto || typeof global.crypto.getRandomValues !== 'function') return '';
    global.crypto.getRandomValues(bytes);
    return Array.prototype.map
      .call(bytes, function (value) {
        return value.toString(16).padStart(2, '0');
      })
      .join('');
  }

  function entryTransitionDelay(scene, reducedMotion) {
    return scene === 'pet' && !reducedMotion ? PET_ENTRY_TRANSITION_DURATION : 0;
  }

  function cleanString(value) {
    return value === null || value === undefined ? '' : String(value).trim();
  }

  function lampAnalytics() {
    return global.QiyuanLampAnalytics || null;
  }

  function analyticsPriceValue(value) {
    var normalized = cleanString(value).replace(/[^0-9.]/g, '');
    var number = Number(normalized);
    return Number.isFinite(number) && number >= 0 ? number : null;
  }

  function isCheckoutDestination(value) {
    try {
      var destination = new global.URL(value, global.location.origin);
      var trustedHost =
        destination.origin === global.location.origin ||
        /\.myshopify\.com$/i.test(destination.hostname) ||
        destination.hostname === 'checkout.shopify.com';
      var checkoutPath = /^\/(?:cart|checkouts?)(?:\/|$)/i.test(destination.pathname);
      return /^https?:$/.test(destination.protocol) && trustedHost && checkoutPath;
    } catch (error) {
      return false;
    }
  }

  function clampSoundVolume(value) {
    return Math.max(0, Math.min(0.15, Number(value) || 0));
  }

  function readSoundSessionValue(key) {
    try {
      return global.sessionStorage ? global.sessionStorage.getItem(key) : null;
    } catch (error) {
      return null;
    }
  }

  function writeSoundSessionValue(key, value) {
    try {
      if (global.sessionStorage) global.sessionStorage.setItem(key, String(value));
    } catch (error) {
      // Sound remains usable when storage is blocked by the browser.
    }
  }

  function requestSoundFrame(callback) {
    if (typeof global.requestAnimationFrame === 'function') {
      return global.requestAnimationFrame(callback);
    }
    return global.setTimeout(function () {
      callback(Date.now());
    }, 16);
  }

  function cancelSoundFrame(frame) {
    if (!frame) return;
    if (typeof global.cancelAnimationFrame === 'function') {
      global.cancelAnimationFrame(frame);
    } else {
      global.clearTimeout(frame);
    }
  }

  function petLampRevealDelay(reducedMotion) {
    return reducedMotion ? 0 : PET_LAMP_REVEAL_DELAY;
  }

  function formatPetLampResult(name) {
    return 'A light for ' + cleanString(name) + ' is now glowing in Qiyuan Garden.';
  }

  function escapeXml(value) {
    return cleanString(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&apos;');
  }

  function wrapCardText(value, maximumLength, maximumLines) {
    var text = cleanString(value).replace(/\s+/g, ' ');
    var words = text.split(' ');
    var lines = [];
    var line = '';

    words.forEach(function (word) {
      var candidate = line ? line + ' ' + word : word;
      if (candidate.length <= maximumLength || !line) {
        line = candidate;
      } else {
        lines.push(line);
        line = word;
      }
    });
    if (line) lines.push(line);

    if (lines.length > maximumLines) {
      lines = lines.slice(0, maximumLines);
      lines[maximumLines - 1] = lines[maximumLines - 1].replace(/[.…]*$/, '') + '…';
    }
    return lines;
  }

  function buildRemembranceCardSvg(selection) {
    var names = escapeXml(selection && selection.names);
    var messageLines = wrapCardText(selection && selection.message, 48, 4);
    var messageMarkup = messageLines
      .map(function (line, index) {
        return (
          '<tspan x="540" dy="' +
          (index === 0 ? 0 : 36) +
          '">' +
          escapeXml(line) +
          '</tspan>'
        );
      })
      .join('');

    return (
      '<svg xmlns="http://www.w3.org/2000/svg" width="1080" height="1350" viewBox="0 0 1080 1350">' +
      '<defs>' +
      '<linearGradient id="background" x1="0" y1="0" x2="1" y2="1">' +
      '<stop offset="0" stop-color="#29231e"/><stop offset="1" stop-color="#51453a"/>' +
      '</linearGradient>' +
      '<radialGradient id="glow"><stop offset="0" stop-color="#fff2bd" stop-opacity=".88"/>' +
      '<stop offset=".38" stop-color="#d9bc7c" stop-opacity=".28"/>' +
      '<stop offset="1" stop-color="#d9bc7c" stop-opacity="0"/></radialGradient>' +
      '</defs>' +
      '<rect width="1080" height="1350" rx="54" fill="url(#background)"/>' +
      '<rect x="42" y="42" width="996" height="1266" rx="34" fill="none" stroke="#d9bc7c" stroke-opacity=".62" stroke-width="2"/>' +
      '<circle cx="540" cy="386" r="246" fill="url(#glow)"/>' +
      '<path d="M540 510c-62-64-62-132 0-190 62 58 62 126 0 190Zm-10 8c-89-14-139-70-132-154 85 9 134 66 132 154Zm20 0c89-14 139-70 132-154-85 9-134 66-132 154Z" fill="none" stroke="#d9bc7c" stroke-width="7" stroke-linecap="round" stroke-linejoin="round"/>' +
      '<path d="M540 442c-22-39-17-77 0-111 20 34 23 72 0 111Z" fill="#fff4c9" stroke="#d9bc7c" stroke-width="5"/>' +
      '<text x="540" y="122" text-anchor="middle" fill="#cdbfa9" font-family="Georgia,serif" font-size="24" letter-spacing="6">QIYUAN GARDEN</text>' +
      '<text x="540" y="660" text-anchor="middle" fill="#fffaf1" font-family="Georgia,serif" font-size="46">A light for</text>' +
      '<text x="540" y="731" text-anchor="middle" fill="#d9bc7c" font-family="Georgia,serif" font-size="54">' +
      names +
      '</text>' +
      '<text x="540" y="824" text-anchor="middle" fill="#fffaf1" font-family="Georgia,serif" font-size="29">' +
      messageMarkup +
      '</text>' +
      '<text x="540" y="1094" text-anchor="middle" fill="#cdbfa9" font-family="Arial,sans-serif" font-size="22">Immediate remembrance preview</text>' +
      '<text x="540" y="1140" text-anchor="middle" fill="#cdbfa9" font-family="Arial,sans-serif" font-size="20">Cultural remembrance only — no spiritual efficacy is claimed.</text>' +
      '<text x="540" y="1212" text-anchor="middle" fill="#fffaf1" font-family="Georgia,serif" font-size="28">Qiyuan Memorial</text>' +
      '</svg>'
    );
  }

  function variantId(value) {
    var normalized = cleanString(value);
    return /^\d+$/.test(normalized) ? normalized : '';
  }

  function actionLabel(scene, action, config) {
    var sceneConfig = config && config.scenes ? config.scenes[scene] : null;

    if (action === 'lamp') return 'Light a Lamp';
    if (action === 'incense') return 'Offer Incense';
    if (action === 'message') {
      return cleanString(sceneConfig && sceneConfig.messageAction) || 'Leave a Message';
    }
    return '';
  }

  function getOffering(config, scene, action, duration) {
    var durationConfig =
      config && config.durations && isDuration(duration) ? config.durations[duration] : null;
    var id = '';
    var price = '';

    if (
      !isHall(scene) ||
      !isAction(action) ||
      !durationConfig ||
      (scene === 'pet' && action === 'incense')
    ) {
      return {
        available: false,
        kind: 'unavailable',
        action: action,
        label: actionLabel(scene, action, config),
        duration: duration,
        durationLabel: cleanString(durationConfig && durationConfig.label),
        variantId: '',
        price: '',
      };
    }

    id = variantId(durationConfig.variantId);
    price = cleanString(durationConfig.price);

    return {
      available: Boolean(id && price),
      kind: id && price ? 'paid' : 'unavailable',
      action: action,
      label: actionLabel(scene, action, config),
      duration: duration,
      durationLabel: cleanString(durationConfig.label),
      variantId: id,
      price: price,
    };
  }

  function buildLineItemProperties(selection) {
    return {
      Hall: cleanString(selection && selection.hall),
      'Dedication Type': cleanString(selection && selection.dedicationType),
      Duration: cleanString(selection && selection.duration),
      'Name or Names': cleanString(selection && selection.names),
      Recipient: cleanString(selection && selection.recipient),
      Privacy: cleanString(selection && selection.privacy),
      Email: cleanString(selection && selection.email),
      Message: cleanString(selection && selection.message),
      'Newsletter Consent': selection && selection.newsletterConsent ? 'Yes' : 'No',
      Source: SOURCE,
    };
  }

  function buildCartPayload(selection) {
    return {
      items: [
        {
          id: selection && selection.offering ? selection.offering.variantId : '',
          quantity: 1,
          properties: buildLineItemProperties(selection),
        },
      ],
    };
  }

  function parseConfig(root) {
    var configNode = root && root.querySelector
      ? root.querySelector('[data-qy-garden-config]')
      : null;

    if (!configNode) return {};

    try {
      return JSON.parse(configNode.textContent || '{}');
    } catch (error) {
      return {};
    }
  }

  function sectionId(root) {
    return root && root.getAttribute
      ? root.getAttribute('data-section-id') || root.id || ''
      : '';
  }

  function getController(root) {
    return controllers ? controllers.get(root) : root.__qiyuanGardenController;
  }

  function setController(root, controller) {
    if (controllers) controllers.set(root, controller);
    else root.__qiyuanGardenController = controller;
  }

  function removeController(root) {
    if (controllers) controllers.delete(root);
    else delete root.__qiyuanGardenController;
  }

  function loadViewerScript(root) {
    var document = global.document;
    var url = root && root.getAttribute ? cleanString(root.getAttribute('data-viewer-src')) : '';

    if (!document || !url) {
      return Promise.reject(new Error('The Qiyuan 3D viewer URL is missing.'));
    }

    if (viewerLoader.promise) {
      if (viewerLoader.url && viewerLoader.url !== url) {
        return Promise.reject(new Error('A different Qiyuan 3D viewer is already loaded.'));
      }
      return viewerLoader.promise;
    }

    viewerLoader.url = url;
    viewerLoader.promise = new Promise(function (resolve, reject) {
      var script = document.querySelector(VIEWER_SCRIPT_SELECTOR);

      function handleLoad() {
        script.setAttribute('data-qiyuan-viewer-state', 'loaded');
        resolve(script);
      }

      function handleError() {
        script.setAttribute('data-qiyuan-viewer-state', 'error');
        viewerLoader.promise = null;
        reject(new Error('The Qiyuan 3D viewer script could not be loaded.'));
      }

      if (script) {
        if (script.getAttribute('data-qiyuan-viewer-state') === 'loaded') {
          resolve(script);
          return;
        }

        if (script.getAttribute('data-qiyuan-viewer-state') === 'error') {
          viewerLoader.promise = null;
          reject(new Error('The Qiyuan 3D viewer script could not be loaded.'));
          return;
        }

        script.addEventListener('load', handleLoad, { once: true });
        script.addEventListener('error', handleError, { once: true });
        return;
      }

      script = document.createElement('script');
      script.src = url;
      script.async = true;
      script.setAttribute('data-qiyuan-shared-viewer', 'true');
      script.setAttribute('data-qiyuan-viewer-state', 'loading');
      script.addEventListener('load', handleLoad, { once: true });
      script.addEventListener('error', handleError, { once: true });
      document.head.appendChild(script);
    });

    return viewerLoader.promise;
  }

  function copyViewerConfiguration(source, target) {
    if (source.id) target.id = source.id;
  }

  function restoreParkedViewer(root) {
    var id = sectionId(root);
    var parked = id ? parkedViewers.get(id) : null;
    var placeholder = root && root.querySelector ? root.querySelector(VIEWER_SELECTOR) : null;

    if (!parked || !placeholder || !placeholder.parentNode) return null;

    copyViewerConfiguration(placeholder, parked);
    placeholder.parentNode.replaceChild(parked, placeholder);
    parkedViewers.delete(id);
    return parked;
  }

  function parkViewers(scope) {
    rootsWithin(scope).forEach(function (root) {
      var controller = getController(root);
      var id = sectionId(root);
      var viewer = root.querySelector(VIEWER_SELECTOR);

      if (controller) controller.disconnect();
      removeController(root);
      if (!id || !viewer) return;

      parkedViewers.set(id, viewer);
      global.document.createDocumentFragment().appendChild(viewer);
    });
  }

  function GardenController(root) {
    this.root = root;
    this.config = parseConfig(root);
    this.activeScene = 'garden';
    this.activeAction = 'lamp';
    this.duration = '1-day';
    this.currentOffering = null;
    this.connected = false;
    this.allowNativeContactSubmit = false;
    this.submitting = false;
    this.pendingScene = '';
    this.pendingSlot = '';
    this.currentSlot = '';
    this.loadedScene = '';
    this.slotScenes = {
      guanyin: '',
      dizang: '',
    };
    this.wasAutoRotating = false;
    this.isNearViewport = !global.IntersectionObserver;
    this.loaderDelayTimer = null;
    this.loaderRevealTimer = null;
    this.loaderProgressValue = 0;
    this.petEntryInProgress = false;
    this.petTransitionTimer = null;
    this.petRevealTimer = null;
    this.petEntryFocusHeading = false;
    this.petLampBusy = false;
    this.petLampLit = false;
    this.petLampIgnitionTimer = null;
    this.petLampRevealTimer = null;
    this.petLampSelection = null;
    this.petLampWasAutoRotating = false;
    this.lampWallRequest = 0;
    this.lampWallAbort = null;
    this.lampLights = [];
    this.lampGroupIndex = 0;
    this.lampRotationTimer = null;
    this.lampTransitionTimer = null;
    this.lampTransitionLocked = false;
    this.lampWallHovered = false;
    this.lampWallFocused = false;
    this.lampCountdownTimer = null;
    this.gardenPublicState = {};
    HALLS.forEach(function (scene) {
      this.gardenPublicState[scene] = { status: 'loading', lights: [] };
    }, this);
    this.gardenOverviewRequested = false;
    this.gardenOverviewAbort = null;
    this.gardenPreviewGroupIndex = 0;
    this.gardenPreviewRotationTimer = null;
    this.soundEnabled = false;
    this.soundFadeFrame = null;
    this.soundFadeToken = 0;
    this.soundResumeTime = Math.max(
      0,
      Number(readSoundSessionValue(GARDEN_SOUND_TIME_KEY)) || 0
    );
    this.showUnavailableOfferings = Boolean(
      this.config && this.config.showUnavailableOfferings
    );

    this.stage = root.querySelector('[data-qy-stage]');
    this.sceneTitle = root.querySelector('[data-qy-scene-title]');
    this.sceneKicker = root.querySelector('[data-qy-scene-kicker]');
    this.sceneSummary = root.querySelector('[data-qy-scene-summary]');
    this.returnButton = root.querySelector('[data-qy-return]');
    this.entrances = root.querySelector('[data-qy-entrances]');
    this.entryButtons = queryAll(root, '[data-qy-enter-hall]');
    this.entranceLiveStates = queryAll(root, '[data-qy-entrance-live]');
    this.gardenOverview = root.querySelector('[data-qy-garden-overview]');
    this.gardenPreviewCards = queryAll(root, '[data-qy-garden-hall-preview]');
    this.hallContent = root.querySelector('[data-qy-hall-content]');
    this.hallTitle = root.querySelector('[data-qy-hall-title]');
    this.hallSummary = root.querySelector('[data-qy-hall-summary]');
    this.fallbackScenes = queryAll(root, '[data-qy-fallback-scene]');
    this.fallbackStatus = root.querySelector('[data-qy-fallback-status]');
    this.modelView = root.querySelector('[data-qy-model-view]');
    this.viewerControls = root.querySelector('[data-qy-viewer-controls]');
    this.loader = root.querySelector('[data-qy-loader]');
    this.loaderSceneTitle = root.querySelector('[data-qy-loader-scene-title]');
    this.loaderSceneTitleZh = root.querySelector('[data-qy-loader-scene-title-zh]');
    this.loaderReturnButton = root.querySelector('[data-qy-loader-return]');
    this.loaderCopy = root.querySelector('[data-qy-loader-copy]');
    this.loaderTitle = root.querySelector('[data-qy-loader-title]');
    this.loaderTitleZh = root.querySelector('[data-qy-loader-title-zh]');
    this.loaderSubtitle = root.querySelector('[data-qy-loader-subtitle]');
    this.loaderProgress = root.querySelector('[data-qy-loader-progress]');
    this.loaderProgressBar = root.querySelector('[data-qy-loader-progress-bar]');
    this.loaderError = root.querySelector('[data-qy-loader-error]');
    this.petTransition = root.querySelector('[data-qy-pet-transition]');
    this.petTransitionCopy = root.querySelector('[data-qy-pet-transition-copy]');
    this.petTransitionError = root.querySelector('[data-qy-pet-transition-error]');
    this.viewer = root.querySelector(VIEWER_SELECTOR);
    this.viewerStatus = this.viewer
      ? this.viewer.querySelector('[data-qiyuan-status]')
      : null;
    this.rotateButton = this.viewer
      ? this.viewer.querySelector('[data-qiyuan-rotate]')
      : null;
    this.resetButton = this.viewer
      ? this.viewer.querySelector('[data-qiyuan-reset]')
      : null;
    this.soundAudio = root.querySelector('[data-qy-garden-sound]');
    this.soundButton = root.querySelector('[data-qy-sound-toggle]');
    this.soundLabel = root.querySelector('[data-qy-sound-label]');
    this.petLampLayer = root.querySelector('[data-qy-pet-lamp-layer]');
    this.petLampMemory = root.querySelector('[data-qy-pet-lamp-memory]');
    this.petLampResult = root.querySelector('[data-qy-pet-lamp-result]');
    this.petLampName = root.querySelector('[data-qy-pet-lamp-name]');
    this.petLampMessage = root.querySelector('[data-qy-pet-lamp-message]');

    this.dedicationForm = root.querySelector('[data-qy-dedication-form]');
    this.newsletterForm = root.querySelector('.qcg-newsletter-form form');
    this.actionButtons = queryAll(root, '[data-qy-action]');
    this.durationOptions = queryAll(root, '[data-qy-duration]');
    this.durationField = root.querySelector('[data-qy-duration]:checked') || this.durationOptions[0];
    this.namesField = root.querySelector('[data-qy-names]');
    this.defaultNamesHelp = root.querySelector('[data-qy-default-names-help]');
    this.petNamesHelp = root.querySelector('[data-qy-pet-names-help]');
    this.recipientField = root.querySelector('[data-qy-recipient]');
    this.privacyOptions = queryAll(root, '[data-qy-privacy]');
    this.privacyField = null;
    this.emailField = root.querySelector('[data-qy-email]');
    this.messageField = root.querySelector('[data-qy-message]');
    this.newsletterConsent = root.querySelector('[data-qy-newsletter-consent]');
    this.previewPanel = root.querySelector('[data-qy-preview-panel]');
    this.paymentPreviewNote = root.querySelector('[data-qy-payment-preview-note]');
    this.petPreviewNote = root.querySelector('[data-qy-pet-preview-note]');
    this.previewButton = root.querySelector('[data-qy-preview]');
    this.confirmButton = root.querySelector('[data-qy-confirm]');
    this.submitError = root.querySelector('[data-qy-submit-error]');
    this.lampWall = root.querySelector('[data-qy-lamp-wall]');
    this.lampWallTitle = root.querySelector('[data-qy-lamp-wall-title]');
    this.lampWallCount = root.querySelector('[data-qy-lamp-wall-count]');
    this.lampWallStatus = root.querySelector('[data-qy-lamp-wall-status]');
    this.lampWallGrid = root.querySelector('[data-qy-lamp-wall-grid]');
    this.lampWallFrame = root.querySelector('[data-qy-lamp-wall-frame]');
    this.lampWallControls = root.querySelector('[data-qy-lamp-wall-controls]');
    this.lampWallEmpty = root.querySelector('[data-qy-lamp-wall-empty]');
    this.liveLampModule = root.querySelector('[data-qy-live-lamp-module]');
    this.lampFormSection = root.querySelector('[data-qy-lamp-form-section]');
    this.previewPlaceholder = root.querySelector('[data-qy-preview-placeholder]');
    this.previewContent = root.querySelector('[data-qy-preview-content]');
    this.namesCount = root.querySelector('[data-qy-names-count]');
    this.messageCount = root.querySelector('[data-qy-message-count]');
    this.motionQuery =
      global.matchMedia && typeof global.matchMedia === 'function'
        ? global.matchMedia('(prefers-reduced-motion: reduce)')
        : null;
    this.intersectionObserver = null;
    this.viewerObserver = null;

    this.handleClick = this.handleClick.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    this.handleInput = this.handleInput.bind(this);
    this.handleModelReady = this.handleModelReady.bind(this);
    this.handleMotionChange = this.handleMotionChange.bind(this);
    this.handleIntersection = this.handleIntersection.bind(this);
    this.handleLampVisibility = this.handleLampVisibility.bind(this);
    this.handleLampResize = this.handleLampResize.bind(this);
    this.handleSoundTimeUpdate = this.saveGardenSoundTime.bind(this);
    this.handleSoundMetadata = this.restoreGardenSoundTime.bind(this);
    this.handleLampEnter = function () { this.lampWallHovered = true; this.clearLampRotation(); }.bind(this);
    this.handleLampLeave = function () { this.lampWallHovered = false; this.scheduleLampRotation(); }.bind(this);
    this.handleLampFocusIn = function () { this.lampWallFocused = true; this.clearLampRotation(); }.bind(this);
    this.handleLampFocusOut = function () { this.lampWallFocused = false; this.scheduleLampRotation(); }.bind(this);
  }

  GardenController.prototype.sceneConfig = function (scene) {
    return this.config && this.config.scenes ? this.config.scenes[scene] || null : null;
  };

  GardenController.prototype.modelUrl = function (scene) {
    var sceneConfig = this.sceneConfig(scene);
    return cleanString(sceneConfig && sceneConfig.modelUrl);
  };

  GardenController.prototype.cancelGardenSoundFade = function () {
    this.soundFadeToken += 1;
    cancelSoundFrame(this.soundFadeFrame);
    this.soundFadeFrame = null;
  };

  GardenController.prototype.saveGardenSoundTime = function () {
    var currentTime;

    if (!this.soundAudio) return;
    currentTime = Number(this.soundAudio.currentTime);
    if (!Number.isFinite(currentTime) || currentTime < 0) return;
    this.soundResumeTime = currentTime;
    writeSoundSessionValue(GARDEN_SOUND_TIME_KEY, currentTime.toFixed(3));
  };

  GardenController.prototype.restoreGardenSoundTime = function () {
    var duration;
    var resumeTime;

    if (!this.soundAudio) return;
    duration = Number(this.soundAudio.duration);
    resumeTime = Math.max(0, Number(this.soundResumeTime) || 0);
    if (Number.isFinite(duration) && duration > 0) resumeTime %= duration;
    try {
      if (resumeTime > 0 && Math.abs(this.soundAudio.currentTime - resumeTime) > 0.25) {
        this.soundAudio.currentTime = resumeTime;
      }
    } catch (error) {
      // The loadedmetadata handler retries once seeking becomes available.
    }
  };

  GardenController.prototype.syncGardenSoundControl = function () {
    var enabledInGarden = this.soundEnabled && this.activeScene === 'garden';

    if (!this.soundButton) return;
    this.soundButton.hidden = this.activeScene !== 'garden';
    this.soundButton.setAttribute('aria-pressed', enabledInGarden ? 'true' : 'false');
    this.soundButton.setAttribute(
      'aria-label',
      enabledInGarden ? 'Turn garden sound off' : 'Turn garden sound on'
    );
    if (this.soundLabel) this.soundLabel.textContent = enabledInGarden ? 'Sound on' : 'Sound off';
  };

  GardenController.prototype.fadeGardenSound = function (target, duration, pauseWhenSilent) {
    var audio = this.soundAudio;
    var startVolume;
    var targetVolume;
    var token;
    var startedAt = null;
    var self = this;

    if (!audio) return;
    this.cancelGardenSoundFade();
    token = this.soundFadeToken;
    startVolume = clampSoundVolume(audio.volume);
    targetVolume = clampSoundVolume(target);

    function finish() {
      audio.volume = targetVolume;
      self.soundFadeFrame = null;
      if (pauseWhenSilent && targetVolume === 0) {
        audio.pause();
        self.saveGardenSoundTime();
      }
    }

    if (!duration || Math.abs(startVolume - targetVolume) < 0.001) {
      finish();
      return;
    }

    function step(timestamp) {
      var progress;
      if (token !== self.soundFadeToken) return;
      if (startedAt === null) startedAt = timestamp;
      progress = Math.min(1, Math.max(0, (timestamp - startedAt) / duration));
      audio.volume = clampSoundVolume(
        startVolume + (targetVolume - startVolume) * progress
      );
      if (progress < 1) self.soundFadeFrame = requestSoundFrame(step);
      else finish();
    }

    this.soundFadeFrame = requestSoundFrame(step);
  };

  GardenController.prototype.disableGardenSound = function () {
    this.soundEnabled = false;
    writeSoundSessionValue(GARDEN_SOUND_ENABLED_KEY, 'false');
    this.syncGardenSoundControl();
    this.fadeGardenSound(0, GARDEN_SOUND_FADE_OUT_DURATION, true);
  };

  GardenController.prototype.resumeGardenSound = function () {
    var playResult;

    if (!this.soundAudio || !this.soundEnabled || this.activeScene !== 'garden') return;
    this.cancelGardenSoundFade();
    this.restoreGardenSoundTime();
    if (this.soundAudio.paused) this.soundAudio.volume = 0;

    try {
      playResult = this.soundAudio.play();
    } catch (error) {
      this.disableGardenSound();
      return;
    }

    Promise.resolve(playResult).then(
      function () {
        if (!this.soundEnabled || this.activeScene !== 'garden') {
          this.fadeGardenSound(0, GARDEN_SOUND_FADE_OUT_DURATION, true);
          return;
        }
        this.fadeGardenSound(
          GARDEN_SOUND_TARGET_VOLUME,
          GARDEN_SOUND_FADE_IN_DURATION,
          false
        );
      }.bind(this),
      function () {
        this.disableGardenSound();
      }.bind(this)
    );
  };

  GardenController.prototype.leaveGardenSound = function () {
    this.syncGardenSoundControl();
    if (!this.soundAudio) return;
    if (this.soundAudio.paused) {
      this.saveGardenSoundTime();
      this.soundAudio.volume = 0;
      return;
    }
    this.fadeGardenSound(0, GARDEN_SOUND_FADE_OUT_DURATION, true);
  };

  GardenController.prototype.toggleGardenSound = function () {
    if (!this.soundAudio || this.activeScene !== 'garden') return;
    if (this.soundEnabled) {
      this.disableGardenSound();
      return;
    }
    this.soundEnabled = true;
    writeSoundSessionValue(GARDEN_SOUND_ENABLED_KEY, 'true');
    this.syncGardenSoundControl();
    this.resumeGardenSound();
  };

  GardenController.prototype.clearLoaderTimers = function () {
    if (this.loaderDelayTimer) {
      global.clearTimeout(this.loaderDelayTimer);
      this.loaderDelayTimer = null;
    }
    if (this.loaderRevealTimer) {
      global.clearTimeout(this.loaderRevealTimer);
      this.loaderRevealTimer = null;
    }
  };

  GardenController.prototype.setLoaderCopy = function (scene) {
    var copy = LOADER_COPY[scene] || LOADER_COPY.garden;

    if (this.loaderSceneTitle) this.loaderSceneTitle.textContent = copy.sceneTitle;
    if (this.loaderSceneTitleZh) this.loaderSceneTitleZh.textContent = copy.sceneTitleZh;
    if (this.loaderTitle) this.loaderTitle.textContent = copy.title;
    if (this.loaderTitleZh) this.loaderTitleZh.textContent = copy.titleZh;
    if (this.loaderSubtitle) this.loaderSubtitle.textContent = copy.subtitle;
    if (this.loaderReturnButton) this.loaderReturnButton.hidden = scene === 'garden';
    if (this.loaderProgress) {
      this.loaderProgress.setAttribute('aria-label', copy.title);
    }
  };

  GardenController.prototype.setLoaderProgress = function (value, reset) {
    var normalized = Math.max(0, Math.min(100, Number(value) || 0));

    if (reset) this.loaderProgressValue = normalized;
    else this.loaderProgressValue = Math.max(this.loaderProgressValue, normalized);
    if (this.loaderProgressBar) {
      this.loaderProgressBar.style.width = this.loaderProgressValue + '%';
    }
    if (this.loaderProgress) {
      this.loaderProgress.setAttribute('aria-valuenow', String(Math.round(this.loaderProgressValue)));
    }
  };

  GardenController.prototype.showLoader = function (scene) {
    if (
      !this.loader ||
      this.activeScene !== scene ||
      this.pendingScene !== scene ||
      this.root.getAttribute('data-model-loading') !== 'true'
    ) {
      return;
    }

    this.loader.hidden = false;
    this.loader.setAttribute('aria-hidden', 'false');
    this.root.setAttribute('data-loader-visible', 'true');
  };

  GardenController.prototype.beginModelLoading = function (scene) {
    var loaderWasVisible = Boolean(this.loader && !this.loader.hidden);

    this.clearLoaderTimers();
    this.root.removeAttribute('data-model-error');
    this.root.setAttribute('data-model-loading', 'true');
    this.setLoaderCopy(scene);
    this.setLoaderProgress(6, true);
    if (this.loaderCopy) this.loaderCopy.hidden = false;
    if (this.loaderError) this.loaderError.hidden = true;

    if (!this.loader) return;
    this.loader.classList.remove('is-leaving');
    if (scene === 'pet' && this.petEntryInProgress) {
      this.loader.hidden = true;
      this.loader.setAttribute('aria-hidden', 'true');
      this.root.removeAttribute('data-loader-visible');
      return;
    }
    if (loaderWasVisible) {
      this.loader.hidden = false;
      this.loader.setAttribute('aria-hidden', 'false');
      this.root.setAttribute('data-loader-visible', 'true');
      return;
    }

    this.loader.hidden = true;
    this.loader.setAttribute('aria-hidden', 'true');
    this.root.removeAttribute('data-loader-visible');
    this.loaderDelayTimer = global.setTimeout(
      function () {
        this.loaderDelayTimer = null;
        this.showLoader(scene);
      }.bind(this),
      LOADER_DELAY
    );
  };

  GardenController.prototype.finishModelLoading = function (scene) {
    var shouldAnimate;

    if (scene && scene !== this.activeScene) return;
    this.clearLoaderTimers();
    this.setLoaderProgress(100);
    this.root.removeAttribute('data-model-error');
    this.root.removeAttribute('data-model-loading');

    if (!this.loader || this.loader.hidden) {
      this.root.removeAttribute('data-loader-visible');
      return;
    }

    shouldAnimate = !this.prefersReducedMotion();
    if (!shouldAnimate) {
      this.loader.hidden = true;
      this.loader.setAttribute('aria-hidden', 'true');
      this.loader.classList.remove('is-leaving');
      this.root.removeAttribute('data-loader-visible');
      return;
    }

    this.loader.classList.add('is-leaving');
    this.loaderRevealTimer = global.setTimeout(
      function () {
        this.loaderRevealTimer = null;
        this.loader.hidden = true;
        this.loader.setAttribute('aria-hidden', 'true');
        this.loader.classList.remove('is-leaving');
        this.root.removeAttribute('data-loader-visible');
      }.bind(this),
      MODEL_REVEAL_DURATION
    );
  };

  GardenController.prototype.showModelError = function (scene) {
    if (scene && scene !== this.activeScene) return;
    this.clearLoaderTimers();
    this.root.setAttribute('data-model-loading', 'true');
    this.root.setAttribute('data-model-error', 'true');
    if (scene === 'pet' && this.petEntryInProgress) {
      if (this.loader) {
        this.loader.hidden = true;
        this.loader.setAttribute('aria-hidden', 'true');
      }
      this.root.removeAttribute('data-loader-visible');
      if (this.modelView) this.modelView.hidden = true;
      if (this.viewerControls) this.viewerControls.hidden = true;
      this.setMediaAccessibility('fallback');
      this.setFallbackMessage('', false);
      this.showPetEntryError();
      return;
    }
    this.setLoaderCopy(scene || this.activeScene);
    this.setLoaderProgress(0, true);
    if (this.loaderCopy) this.loaderCopy.hidden = true;
    if (this.loaderError) this.loaderError.hidden = false;
    if (this.loader) {
      this.loader.classList.remove('is-leaving');
      this.loader.hidden = false;
      this.loader.setAttribute('aria-hidden', 'false');
      this.root.setAttribute('data-loader-visible', 'true');
    }
    if (this.modelView) this.modelView.hidden = true;
    if (this.viewerControls) this.viewerControls.hidden = true;
    this.setMediaAccessibility('fallback');
    this.setFallbackMessage('', false);
  };

  GardenController.prototype.retryModel = function () {
    var failedScript = global.document.querySelector(
      VIEWER_SCRIPT_SELECTOR + '[data-qiyuan-viewer-state="error"]'
    );

    if (failedScript && failedScript.parentNode) failedScript.parentNode.removeChild(failedScript);
    if (failedScript) {
      viewerLoader.promise = null;
      viewerLoader.url = '';
    }
    if (this.viewer) this.viewer.classList.remove('q3d-has-error');
    if (this.viewerStatus) {
      this.viewerStatus.classList.remove('is-error');
      this.viewerStatus.textContent = 'Preparing the garden…';
    }
    this.pendingScene = '';
    this.pendingSlot = '';
    if (this.modelView) this.modelView.hidden = false;
    this.configureModel(this.activeScene);
  };

  GardenController.prototype.clearPetTransitionTimers = function () {
    if (this.petTransitionTimer) {
      global.clearTimeout(this.petTransitionTimer);
      this.petTransitionTimer = null;
    }
    if (this.petRevealTimer) {
      global.clearTimeout(this.petRevealTimer);
      this.petRevealTimer = null;
    }
  };

  GardenController.prototype.setPetEntryBusy = function (busy) {
    var petButton = this.root.querySelector('[data-qy-enter-hall="pet"]');

    this.root.toggleAttribute('data-pet-entry-in-progress', busy);
    if (petButton) {
      petButton.disabled = busy;
      petButton.setAttribute('aria-busy', busy ? 'true' : 'false');
    }
  };

  GardenController.prototype.showPetTransition = function (showError) {
    if (!this.petTransition) return;
    this.petTransition.classList.remove('is-leaving');
    this.petTransition.hidden = false;
    this.petTransition.setAttribute('aria-hidden', 'false');
    this.root.setAttribute(
      'data-pet-transition-state',
      showError ? 'error' : 'entering'
    );
    if (this.petTransitionCopy) this.petTransitionCopy.hidden = Boolean(showError);
    if (this.petTransitionError) this.petTransitionError.hidden = !showError;
  };

  GardenController.prototype.hidePetTransition = function () {
    if (!this.petTransition) return;
    this.petTransition.hidden = true;
    this.petTransition.setAttribute('aria-hidden', 'true');
    this.petTransition.classList.remove('is-leaving');
    this.root.removeAttribute('data-pet-transition-state');
  };

  GardenController.prototype.beginPetEntry = function (focusHeading) {
    var delay;

    if (this.petEntryInProgress || this.activeScene === 'pet') return false;
    this.petEntryInProgress = true;
    this.petEntryFocusHeading = Boolean(focusHeading);
    this.clearPetTransitionTimers();
    this.setPetEntryBusy(true);
    this.hidePreview();
    this.clearSubmitError();
    if (this.hallContent) this.hallContent.hidden = true;
    if (this.entrances) this.entrances.hidden = true;
    if (this.gardenOverview) this.gardenOverview.hidden = true;
    this.clearGardenPreviewRotation();
    if (this.returnButton) this.returnButton.hidden = true;
    this.showPetTransition(false);
    this.pauseViewer(false);
    this.scrollToScene(focusHeading);

    delay = entryTransitionDelay('pet', this.prefersReducedMotion());
    if (!delay) {
      this.startPetModelLoad();
      return true;
    }

    this.petTransitionTimer = global.setTimeout(
      function () {
        this.petTransitionTimer = null;
        this.startPetModelLoad();
      }.bind(this),
      delay
    );
    return true;
  };

  GardenController.prototype.startPetModelLoad = function () {
    var self = this;

    if (!this.petEntryInProgress) return;
    this.isNearViewport = true;
    this.entryButtons.forEach(function (button) {
      button.setAttribute(
        'aria-expanded',
        button.getAttribute('data-qy-enter-hall') === 'pet' ? 'true' : 'false'
      );
    });
    if (this.hallContent) this.hallContent.hidden = true;
    this.showScene('pet');
    this.updateHallContent('pet');

    global.requestAnimationFrame(function () {
      if (
        self.petEntryInProgress &&
        self.activeScene === 'pet' &&
        self.loadedScene === 'pet' &&
        !self.pendingScene
      ) {
        self.completePetEntry();
      }
    });
  };

  GardenController.prototype.revealPetHall = function () {
    if (!this.petEntryInProgress || this.activeScene !== 'pet') return;
    this.petRevealTimer = null;
    this.hidePetTransition();
    if (this.hallContent) this.hallContent.hidden = false;
    if (this.returnButton) this.returnButton.hidden = false;
    this.setPetEntryBusy(false);
    this.petEntryInProgress = false;
    this.petEntryFocusHeading = false;
  };

  GardenController.prototype.completePetEntry = function () {
    if (!this.petEntryInProgress || this.activeScene !== 'pet') return;
    this.clearPetTransitionTimers();
    if (this.prefersReducedMotion() || !this.petTransition) {
      this.revealPetHall();
      return;
    }

    this.petTransition.classList.add('is-leaving');
    this.petRevealTimer = global.setTimeout(
      function () {
        this.revealPetHall();
      }.bind(this),
      PET_ENTRY_REVEAL_DURATION
    );
  };

  GardenController.prototype.showPetEntryError = function () {
    if (!this.petEntryInProgress || this.activeScene !== 'pet') return;
    this.clearPetTransitionTimers();
    if (this.hallContent) this.hallContent.hidden = true;
    if (this.returnButton) this.returnButton.hidden = true;
    this.showPetTransition(true);
  };

  GardenController.prototype.retryPetEntry = function () {
    if (!this.petEntryInProgress || this.activeScene !== 'pet') return;
    this.showPetTransition(false);
    this.retryModel();
  };

  GardenController.prototype.cancelPetEntry = function () {
    this.clearPetTransitionTimers();
    this.hidePetTransition();
    this.setPetEntryBusy(false);
    this.petEntryInProgress = false;
    this.petEntryFocusHeading = false;
  };

  GardenController.prototype.setFallbackScene = function (scene) {
    this.fallbackScenes.forEach(function (fallback) {
      var selected = fallback.getAttribute('data-qy-fallback-scene') === scene;
      fallback.hidden = !selected;
      fallback.setAttribute('aria-hidden', selected ? 'false' : 'true');
    });
  };

  GardenController.prototype.setFallbackMessage = function (message, visible) {
    if (!this.fallbackStatus) return;
    this.fallbackStatus.textContent = message;
    this.fallbackStatus.hidden = !visible;
  };

  GardenController.prototype.setMediaAccessibility = function (state) {
    var fallbackStack = this.root.querySelector('[data-qy-fallback-stack]');
    var canvas = this.viewer ? this.viewer.querySelector('[data-qiyuan-canvas]') : null;
    var viewerIsReady = state === 'ready';
    var viewerIsPresent = state === 'ready' || state === 'loading';

    if (fallbackStack) {
      fallbackStack.setAttribute('aria-hidden', viewerIsReady ? 'true' : 'false');
    }
    if (this.modelView) {
      this.modelView.setAttribute('aria-hidden', viewerIsPresent ? 'false' : 'true');
    }
    if (canvas) {
      canvas.setAttribute('tabindex', viewerIsReady ? '0' : '-1');
    }
  };

  GardenController.prototype.pauseViewer = function (remember) {
    if (!this.rotateButton) return;
    if (this.rotateButton.getAttribute('aria-pressed') === 'true') {
      if (remember) this.wasAutoRotating = true;
      this.rotateButton.click();
    }
  };

  GardenController.prototype.resumeViewer = function () {
    if (
      !this.rotateButton ||
      !this.wasAutoRotating ||
      (this.motionQuery && this.motionQuery.matches) ||
      this.modelView.hidden
    ) {
      return;
    }

    if (this.rotateButton.getAttribute('aria-pressed') !== 'true') {
      this.rotateButton.click();
    }
    this.wasAutoRotating = false;
  };

  GardenController.prototype.clearPetLampTimers = function () {
    if (this.petLampIgnitionTimer) {
      global.clearTimeout(this.petLampIgnitionTimer);
      this.petLampIgnitionTimer = null;
    }
    if (this.petLampRevealTimer) {
      global.clearTimeout(this.petLampRevealTimer);
      this.petLampRevealTimer = null;
    }
  };

  GardenController.prototype.stabilizePetViewer = function () {
    this.petLampWasAutoRotating = Boolean(
      this.rotateButton && this.rotateButton.getAttribute('aria-pressed') === 'true'
    );

    if (this.petLampWasAutoRotating) this.rotateButton.click();
    if (this.resetButton && !this.resetButton.disabled) this.resetButton.click();
    if (this.rotateButton) this.rotateButton.disabled = true;
    if (this.resetButton) this.resetButton.disabled = true;
    if (this.viewerControls) this.viewerControls.hidden = true;
    this.root.setAttribute('data-pet-lamp-active', 'true');
  };

  GardenController.prototype.releasePetViewer = function (resumeRotation) {
    if (this.rotateButton) this.rotateButton.disabled = false;
    if (this.resetButton) this.resetButton.disabled = false;
    if (
      this.viewerControls &&
      this.activeScene === 'pet' &&
      this.loadedScene === 'pet' &&
      !this.pendingScene
    ) {
      this.viewerControls.hidden = false;
    }
    this.root.removeAttribute('data-pet-lamp-active');

    if (
      resumeRotation &&
      this.petLampWasAutoRotating &&
      !this.prefersReducedMotion() &&
      this.rotateButton &&
      this.rotateButton.getAttribute('aria-pressed') !== 'true'
    ) {
      this.rotateButton.click();
    }
    this.petLampWasAutoRotating = false;
  };

  GardenController.prototype.resetPetLamp = function (options) {
    var settings = options || {};

    this.clearPetLampTimers();
    this.petLampBusy = false;
    this.petLampLit = false;
    this.petLampSelection = null;
    if (this.petLampLayer) {
      this.petLampLayer.hidden = true;
      this.petLampLayer.setAttribute('aria-hidden', 'true');
      this.petLampLayer.setAttribute('data-state', 'idle');
    }
    if (this.petLampMemory) this.petLampMemory.hidden = true;
    if (this.petLampResult) this.petLampResult.textContent = '';
    if (this.petLampName) this.petLampName.textContent = '';
    if (this.petLampMessage) this.petLampMessage.textContent = '';
    if (this.previewButton && this.activeScene === 'pet') this.previewButton.disabled = false;
    this.releasePetViewer(Boolean(settings.resumeRotation));

    if (settings.clearFields) {
      if (this.namesField) this.namesField.value = '';
      if (this.messageField) this.messageField.value = '';
    }
    if (settings.focusNames && this.namesField) {
      this.namesField.focus({ preventScroll: true });
      this.namesField.scrollIntoView({
        behavior: this.prefersReducedMotion() ? 'auto' : 'smooth',
        block: 'center',
      });
    }
  };

  GardenController.prototype.revealPetLamp = function () {
    var selection = this.petLampSelection;

    if (!this.petLampBusy || this.activeScene !== 'pet' || !selection) return;
    this.clearPetLampTimers();
    this.petLampBusy = false;
    this.petLampLit = true;
    if (this.petLampLayer) this.petLampLayer.setAttribute('data-state', 'lit');
    if (this.petLampResult) {
      this.petLampResult.textContent = formatPetLampResult(selection.names);
    }
    if (this.petLampName) this.petLampName.textContent = selection.names;
    if (this.petLampMessage) this.petLampMessage.textContent = selection.message;
    if (this.petLampMemory) {
      this.petLampMemory.hidden = false;
      this.petLampMemory.focus({ preventScroll: true });
    }
    if (this.previewPanel) this.previewPanel.hidden = false;
    if (this.previewButton) this.previewButton.disabled = true;
  };

  GardenController.prototype.lightPetLamp = function () {
    var delay;
    var selection;

    if (this.activeScene !== 'pet' || this.petLampBusy || this.petLampLit) return false;
    this.clearSubmitError();
    if (!this.validateFields()) return false;

    selection = this.selection();
    this.petLampSelection = selection;
    this.petLampBusy = true;
    this.fillPreview(selection);
    this.hidePreview();
    if (this.previewButton) this.previewButton.disabled = true;
    this.stabilizePetViewer();
    if (this.petLampLayer) {
      this.petLampLayer.hidden = false;
      this.petLampLayer.setAttribute('aria-hidden', 'false');
      this.petLampLayer.setAttribute('data-state', 'preparing');
    }
    if (this.petLampMemory) this.petLampMemory.hidden = true;
    this.scrollToScene(true);

    delay = petLampRevealDelay(this.prefersReducedMotion());
    if (!delay) {
      if (this.petLampLayer) this.petLampLayer.setAttribute('data-state', 'lighting');
      this.revealPetLamp();
      return true;
    }

    this.petLampIgnitionTimer = global.setTimeout(
      function () {
        this.petLampIgnitionTimer = null;
        if (this.petLampBusy && this.petLampLayer) {
          this.petLampLayer.setAttribute('data-state', 'lighting');
        }
      }.bind(this),
      PET_LAMP_IGNITION_DELAY
    );
    this.petLampRevealTimer = global.setTimeout(
      function () {
        this.petLampRevealTimer = null;
        this.revealPetLamp();
      }.bind(this),
      delay
    );
    return true;
  };

  GardenController.prototype.downloadRemembranceCard = function () {
    var anchor;
    var blob;
    var filenameName;
    var url;

    if (
      !this.petLampLit ||
      !this.petLampSelection ||
      !global.Blob ||
      !global.URL ||
      !global.URL.createObjectURL
    ) {
      return;
    }

    blob = new global.Blob([buildRemembranceCardSvg(this.petLampSelection)], {
      type: 'image/svg+xml;charset=utf-8',
    });
    url = global.URL.createObjectURL(blob);
    filenameName = cleanString(this.petLampSelection.names)
      .replace(/[^a-z0-9]+/gi, '-')
      .replace(/^-|-$/g, '')
      .slice(0, 48);
    anchor = global.document.createElement('a');
    anchor.href = url;
    anchor.download = 'qiyuan-remembrance-' + (filenameName || 'card') + '.svg';
    anchor.hidden = true;
    global.document.body.appendChild(anchor);
    anchor.click();
    anchor.remove();
    global.setTimeout(function () {
      global.URL.revokeObjectURL(url);
    }, 0);
  };

  GardenController.prototype.selectModelSlot = function (scene) {
    var url = this.modelUrl(scene);
    var initialized =
      this.viewer && this.viewer.getAttribute('data-qiyuan-initialized') === 'true';
    var activeSlot =
      this.viewer && this.viewer.getAttribute('data-model-kind')
        ? this.viewer.getAttribute('data-model-kind')
        : this.currentSlot;
    var slot;

    if (this.viewer && this.viewer.getAttribute('data-guanyin-src') === url) {
      slot = 'guanyin';
    } else if (this.viewer && this.viewer.getAttribute('data-dizang-src') === url) {
      slot = 'dizang';
    } else if (!initialized && !this.currentSlot) {
      slot = 'guanyin';
    } else if (this.slotScenes.guanyin === scene) {
      slot = 'guanyin';
    } else if (this.slotScenes.dizang === scene) {
      slot = 'dizang';
    } else {
      slot = activeSlot === 'guanyin' ? 'dizang' : 'guanyin';
    }

    return slot;
  };

  GardenController.prototype.configureModel = function (scene) {
    var url = this.modelUrl(scene);
    var slot;
    var attribute;
    var button;
    var description;
    var initialized;
    var activeSlot;

    if (!url || !this.viewer) return;

    if (
      this.loadedScene === scene &&
      (!this.pendingScene || this.pendingScene === scene) &&
      this.viewer.getAttribute('data-qiyuan-initialized') === 'true'
    ) {
      this.finishModelLoading(scene);
      if (this.modelView) this.modelView.hidden = false;
      if (this.viewerControls) this.viewerControls.hidden = false;
      this.setMediaAccessibility('ready');
      this.setFallbackMessage('', false);
      this.resumeViewer();
      return;
    }

    slot = this.selectModelSlot(scene);
    initialized = this.viewer.getAttribute('data-qiyuan-initialized') === 'true';
    activeSlot = this.viewer.getAttribute('data-model-kind') || this.currentSlot;
    if (initialized && slot === activeSlot && this.loadedScene !== scene) {
      slot = activeSlot === 'guanyin' ? 'dizang' : 'guanyin';
    }
    attribute = slot === 'guanyin' ? 'data-guanyin-src' : 'data-dizang-src';
    this.viewer.setAttribute(attribute, url);
    this.slotScenes[slot] = scene;
    this.currentSlot = slot;
    this.pendingSlot = slot;
    this.pendingScene = scene;
    this.beginModelLoading(scene);
    if (this.viewerControls) this.viewerControls.hidden = true;
    this.setMediaAccessibility('loading');

    description = this.viewer.querySelector('[data-qiyuan-description="' + slot + '"]');
    if (description) {
      var sceneConfig = this.sceneConfig(scene);
      description.textContent =
        cleanString(sceneConfig && sceneConfig.title) + ' interactive 3D scene';
    }

    if (!initialized) {
      this.viewer.setAttribute('data-initial-model', slot);
    }

    this.setFallbackMessage('', false);

    loadViewerScript(this.root)
      .then(
        function () {
          this.setLoaderProgress(18);
          if (!initialized) return;
          button = this.viewer.querySelector('[data-qiyuan-model-btn="' + slot + '"]');
          if (button && !button.disabled) button.click();
        }.bind(this)
      )
      .catch(
        function () {
          if (this.pendingScene !== scene) return;
          this.showModelError(scene);
        }.bind(this)
      );
  };

  GardenController.prototype.showScene = function (scene) {
    var sceneConfig = this.sceneConfig(scene) || {};
    var url = this.modelUrl(scene);

    this.activeScene = scene;
    this.root.setAttribute('data-active-scene', scene);
    this.syncGardenSoundControl();
    if (scene === 'garden' && this.soundEnabled) this.resumeGardenSound();
    this.setFallbackScene(scene);
    this.setLoaderCopy(scene);

    if (this.sceneKicker) this.sceneKicker.textContent = cleanString(sceneConfig.kicker);
    if (this.sceneSummary) this.sceneSummary.textContent = cleanString(sceneConfig.summary);
    if (this.sceneTitle) {
      this.sceneTitle.textContent = '';
      this.sceneTitle.appendChild(global.document.createTextNode(cleanString(sceneConfig.title)));
      if (sceneConfig.titleZh) {
        var titleZh = global.document.createElement('span');
        titleZh.lang = 'zh';
        titleZh.textContent = cleanString(sceneConfig.titleZh);
        this.sceneTitle.appendChild(titleZh);
      }
    }

    if (!url) {
      this.pendingScene = '';
      this.pendingSlot = '';
      this.pauseViewer(true);
      this.showModelError(scene);
      return;
    }

    if (!this.isNearViewport) {
      if (this.modelView) this.modelView.hidden = true;
      if (this.viewerControls) this.viewerControls.hidden = true;
      this.setMediaAccessibility('fallback');
      this.setFallbackMessage('', false);
      return;
    }

    if (this.modelView) this.modelView.hidden = false;
    this.configureModel(scene);
  };

  GardenController.prototype.actionAvailable = function (action) {
    var self = this;
    if (action === 'incense' && this.activeScene === 'pet') return false;
    return DURATIONS.some(function (duration) {
      return getOffering(self.config, self.activeScene, action, duration).available;
    });
  };

  GardenController.prototype.syncActionButtons = function () {
    var self = this;

    this.actionButtons.forEach(function (button) {
      var action = button.getAttribute('data-qy-action');
      var applicable = !(self.activeScene === 'pet' && action === 'incense');
      var available = applicable && self.actionAvailable(action);
      var visible = applicable && (available || self.showUnavailableOfferings);

      button.hidden = !visible;
      button.disabled = !available && !self.showUnavailableOfferings;
      button.setAttribute('aria-disabled', available ? 'false' : 'true');
    });
  };

  GardenController.prototype.syncDurationOptions = function () {
    if (this.durationOptions.length && this.durationOptions[0].type === 'radio') {
      this.durationOptions.forEach(function (option) {
        option.checked = option.value === this.duration;
      }, this);
      this.durationField = this.root.querySelector('[data-qy-duration]:checked') || this.durationOptions[0];
      return;
    }
    var self = this;
    var firstAvailable = '';

    this.durationOptions.forEach(function (option) {
      var duration = option.value;
      var offering = getOffering(
        self.config,
        self.activeScene,
        self.activeAction,
        duration
      );
      var durationConfig =
        self.config && self.config.durations
          ? self.config.durations[duration]
          : null;
      var label = cleanString(durationConfig && durationConfig.label) || option.textContent;

      if (offering.available && !firstAvailable) firstAvailable = duration;
      option.disabled = !offering.available;
      option.hidden = !offering.available && !self.showUnavailableOfferings;
      option.textContent =
        offering.available
          ? label + ' — ' + offering.price
          : label + (self.showUnavailableOfferings ? ' — Not yet available' : '');
    });

    if (
      !getOffering(
        this.config,
        this.activeScene,
        this.activeAction,
        this.duration
      ).available &&
      !this.showUnavailableOfferings &&
      firstAvailable
    ) {
      this.duration = firstAvailable;
      if (this.durationField) this.durationField.value = firstAvailable;
    }
  };

  GardenController.prototype.updateHallContent = function (scene) {
    var sceneConfig = this.sceneConfig(scene) || {};
    var moduleHall = this.root.querySelector('[data-qy-module-hall]');

    if (this.hallTitle) {
      this.hallTitle.textContent = '';
      this.hallTitle.appendChild(global.document.createTextNode(cleanString(sceneConfig.title)));
      if (sceneConfig.titleZh) {
        var titleZh = global.document.createElement('span');
        titleZh.lang = 'zh';
        titleZh.textContent = cleanString(sceneConfig.titleZh);
        this.hallTitle.appendChild(titleZh);
      }
    }
    if (this.hallSummary) this.hallSummary.textContent = cleanString(sceneConfig.summary);
    if (moduleHall) moduleHall.textContent = cleanString(sceneConfig.title) || 'Memorial Hall';
    if (this.liveLampModule) this.liveLampModule.setAttribute('data-hall-code', hallCodeForScene(scene));
    this.hidePreview();
    this.updateSelectionStatus();
    this.loadLampWall(scene);
  };

  GardenController.prototype.formatLampTime = function (expiresAt) {
    var remaining = Math.max(0, new Date(expiresAt).getTime() - Date.now());
    var minutes = Math.floor(remaining / 60000);
    var days = Math.floor(minutes / 1440);
    var hours = Math.floor((minutes % 1440) / 60);

    if (days) return days + 'd ' + hours + 'h remaining';
    if (hours) return hours + 'h ' + (minutes % 60) + 'm remaining';
    return Math.max(0, minutes) + 'm remaining';
  };

  GardenController.prototype.clearGardenPreviewRotation = function () {
    if (this.gardenPreviewRotationTimer) {
      global.clearTimeout(this.gardenPreviewRotationTimer);
      this.gardenPreviewRotationTimer = null;
    }
  };

  GardenController.prototype.activeGardenLights = function (scene) {
    var state = this.gardenPublicState[scene];
    return activePublicLights(state && state.lights);
  };

  GardenController.prototype.scheduleGardenPreviewRotation = function () {
    var hasAdditionalLights = HALLS.some(function (scene) {
      return this.activeGardenLights(scene).length > GARDEN_PREVIEW_LIMIT;
    }, this);

    this.clearGardenPreviewRotation();
    if (
      this.activeScene !== 'garden' ||
      this.prefersReducedMotion() ||
      global.document.hidden ||
      !hasAdditionalLights
    ) return;

    this.gardenPreviewRotationTimer = global.setTimeout(function () {
      this.gardenPreviewGroupIndex += 1;
      HALLS.forEach(function (scene) {
        this.renderGardenPublicState(scene);
      }, this);
      this.scheduleGardenPreviewRotation();
    }.bind(this), GARDEN_PREVIEW_ROTATION_INTERVAL);
  };

  GardenController.prototype.renderGardenEntranceState = function (scene, state, lights) {
    var liveState = this.entranceLiveStates.find(function (node) {
      return node.getAttribute('data-qy-entrance-live') === scene;
    });
    var count;
    var latest;

    if (!liveState) return;
    count = liveState.querySelector('[data-qy-entrance-count]');
    latest = liveState.querySelector('[data-qy-entrance-latest]');

    if (state.status === 'loading') {
      if (count) count.textContent = 'Gathering lights…';
      if (latest) latest.hidden = true;
      return;
    }
    if (state.status === 'error') {
      if (count) count.textContent = 'Lights temporarily unavailable';
      if (latest) latest.hidden = true;
      return;
    }

    if (count) {
      count.textContent = lights.length
        ? lights.length + (lights.length === 1 ? ' light glowing' : ' lights glowing')
        : 'The hall is open for remembrance.';
    }
    if (latest) {
      latest.hidden = !lights.length;
      latest.textContent = lights.length ? 'For ' + publicLampName(lights[0]) : '';
    }
  };

  GardenController.prototype.createGardenPreviewLamp = function (light, scene) {
    var card = global.document.createElement('article');
    var visual = global.document.createElement('div');
    var image = global.document.createElement('img');
    var hall = global.document.createElement('small');
    var name = global.document.createElement('strong');
    var time = global.document.createElement('span');
    var sceneConfig = this.sceneConfig(scene) || {};

    card.className = 'qcg-garden-preview-lamp';
    card.setAttribute('role', 'listitem');
    visual.className = 'qcg-garden-preview-lamp-visual';
    visual.setAttribute('aria-hidden', 'true');
    image.src = cleanString(this.gardenOverview && this.gardenOverview.getAttribute('data-lamp-asset')) || LAMP_ASSET_URL;
    image.alt = '';
    image.width = 1254;
    image.height = 1254;
    image.loading = 'lazy';
    image.decoding = 'async';
    visual.appendChild(image);
    hall.textContent = cleanString(sceneConfig.title) || 'Memorial Hall';
    name.textContent = publicLampName(light);
    time.textContent = this.formatLampTime(light.expires_at);
    time.setAttribute('data-qy-garden-lamp-expires', cleanString(light.expires_at));
    card.appendChild(visual);
    card.appendChild(hall);
    card.appendChild(name);
    card.appendChild(time);
    return card;
  };

  GardenController.prototype.renderGardenPublicState = function (scene) {
    var state = this.gardenPublicState[scene] || { status: 'loading', lights: [] };
    var lights = state.status === 'success' ? this.activeGardenLights(scene) : [];
    var card = this.gardenPreviewCards.find(function (node) {
      return node.getAttribute('data-qy-garden-hall-preview') === scene;
    });
    var count;
    var status;
    var list;

    this.renderGardenEntranceState(scene, state, lights);
    if (!card) return;
    count = card.querySelector('[data-qy-garden-preview-count]');
    status = card.querySelector('[data-qy-garden-preview-status]');
    list = card.querySelector('[data-qy-garden-preview-lights]');
    card.setAttribute('data-state', state.status);
    card.setAttribute('aria-busy', state.status === 'loading' ? 'true' : 'false');
    if (list) list.replaceChildren();

    if (state.status === 'loading') {
      if (count) count.textContent = 'Gathering lights…';
      if (status) {
        status.hidden = false;
        status.textContent = 'Gathering this hall’s public lights…';
      }
      return;
    }
    if (state.status === 'error') {
      if (count) count.textContent = 'Lights temporarily unavailable';
      if (status) {
        status.hidden = false;
        status.textContent = 'Lights are temporarily unavailable.';
      }
      return;
    }

    state.activeCount = lights.length;

    if (count) {
      count.textContent = lights.length
        ? lights.length + (lights.length === 1 ? ' public light glowing now' : ' public lights glowing now')
        : 'The hall is open for remembrance.';
    }
    if (!lights.length) {
      if (status) {
        status.hidden = false;
        status.textContent = 'The hall is open for remembrance.';
      }
      return;
    }

    if (status) status.hidden = true;
    if (!list) return;
    gardenPreviewLights(lights, this.gardenPreviewGroupIndex).forEach(function (light) {
      list.appendChild(this.createGardenPreviewLamp(light, scene));
    }, this);
  };

  GardenController.prototype.loadGardenOverview = function () {
    if (this.gardenOverviewRequested || !this.gardenOverview || !global.fetch) return;
    this.gardenOverviewRequested = true;
    this.gardenOverviewAbort = typeof global.AbortController === 'function' ? new global.AbortController() : null;

    HALLS.forEach(function (scene) {
      var hallCode = hallCodeForScene(scene);
      this.renderGardenPublicState(scene);
      global.fetch('/apps/qiyuan-lights/lights?hall_code=' + encodeURIComponent(hallCode), {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
        cache: 'no-store',
        signal: this.gardenOverviewAbort ? this.gardenOverviewAbort.signal : undefined,
      })
        .then(function (response) {
          if (!response.ok) throw new Error('garden_lights_unavailable');
          return response.json();
        })
        .then(function (payload) {
          var lights = Array.isArray(payload)
            ? payload
            : payload && Array.isArray(payload.lights)
              ? payload.lights
              : [];
          this.gardenPublicState[scene] = { status: 'success', lights: lights };
          this.renderGardenPublicState(scene);
          this.scheduleGardenPreviewRotation();
        }.bind(this))
        .catch(function () {
          if (this.gardenOverviewAbort && this.gardenOverviewAbort.signal.aborted) return;
          this.gardenPublicState[scene] = { status: 'error', lights: [] };
          this.renderGardenPublicState(scene);
        }.bind(this));
    }, this);
  };

  GardenController.prototype.lampCapacity = function () {
    return lampCapacityForWidth(global.innerWidth || 1440);
  };

  GardenController.prototype.activeLampLights = function () {
    var now = Date.now();
    return this.lampLights
      .filter(function (light) {
        return new Date(light.expires_at).getTime() > now;
      })
      .sort(function (left, right) {
        var difference = new Date(right.starts_at).getTime() - new Date(left.starts_at).getTime();
        return difference || cleanString(right.public_id).localeCompare(cleanString(left.public_id));
      });
  };

  GardenController.prototype.lampGroups = function (lights) {
    return groupLampLights(lights, this.lampCapacity());
  };

  GardenController.prototype.createLampCard = function (light) {
    var card = global.document.createElement('article');
    var visual = global.document.createElement('div');
    var image = global.document.createElement('img');
    var name = global.document.createElement('h4');
    var time = global.document.createElement('p');
    card.className = 'qcg-lamp-card';
    card.setAttribute('role', 'listitem');
    visual.className = 'qcg-lamp-card-visual';
    visual.setAttribute('aria-hidden', 'true');
    image.src = cleanString(this.liveLampModule && this.liveLampModule.getAttribute('data-lamp-asset')) || LAMP_ASSET_URL;
    image.alt = '';
    image.width = 1254;
    image.height = 1254;
    image.loading = 'lazy';
    image.decoding = 'async';
    visual.appendChild(image);
    name.textContent = cleanString(light.display_name) || 'Anonymous';
    time.setAttribute('data-qy-lamp-expires', cleanString(light.expires_at));
    time.textContent = this.formatLampTime(light.expires_at);
    card.appendChild(visual);
    card.appendChild(name);
    card.appendChild(time);
    return card;
  };

  GardenController.prototype.createLampGroup = function (lights) {
    var group = global.document.createElement('div');
    group.className = 'qcg-lamp-group';
    group.setAttribute('data-qy-lamp-group', '');
    lights.forEach(function (light) {
      group.appendChild(this.createLampCard(light));
    }, this);
    return group;
  };

  GardenController.prototype.clearLampRotation = function () {
    if (this.lampRotationTimer) global.clearTimeout(this.lampRotationTimer);
    this.lampRotationTimer = null;
  };

  GardenController.prototype.canRotateLamps = function (groupCount) {
    return groupCount > 1 && !this.prefersReducedMotion() && !global.document.hidden &&
      !this.lampWallHovered && !this.lampWallFocused;
  };

  GardenController.prototype.scheduleLampRotation = function () {
    var groups = this.lampGroups(this.activeLampLights());
    this.clearLampRotation();
    if (!this.canRotateLamps(groups.length)) return;
    this.lampRotationTimer = global.setTimeout(function () {
      this.changeLampGroup(1);
    }.bind(this), LAMP_ROTATION_INTERVAL);
  };

  GardenController.prototype.setLampWallMeta = function (lights, groups) {
    if (this.lampWallCount) {
      this.lampWallCount.textContent = lights.length
        ? lights.length + (lights.length === 1 ? ' light glowing now' : ' lights glowing now')
        : 'The hall is open for remembrance.';
    }
    if (this.lampWallControls) this.lampWallControls.hidden = groups.length <= 1;
    if (this.lampWallStatus) {
      this.lampWallStatus.textContent = groups.length > 1
        ? 'Showing group ' + (this.lampGroupIndex + 1) + ' of ' + groups.length + '. Active public lights, newest first.'
        : lights.length ? 'Active public lights, newest first.' : '';
    }
  };

  GardenController.prototype.renderLiveLampWall = function (lights, scene, preserveIndex) {
    var active;
    var groups;
    if (this.activeScene !== scene || !this.lampWallGrid) return;
    this.lampLights = Array.isArray(lights) ? lights : [];
    active = this.activeLampLights();
    groups = this.lampGroups(active);
    this.clearLampRotation();
    this.lampWallGrid.replaceChildren();
    this.lampWallGrid.setAttribute('aria-busy', 'false');
    if (!groups.length) {
      this.lampGroupIndex = 0;
      this.lampWallGrid.hidden = true;
      if (this.lampWallEmpty) this.lampWallEmpty.hidden = false;
      this.setLampWallMeta(active, groups);
      if (this.lampWallStatus) this.lampWallStatus.textContent = '';
      return;
    }
    if (!preserveIndex) {
      this.lampGroupIndex = Math.floor(Date.now() / LAMP_ROTATION_INTERVAL) % groups.length;
    } else {
      this.lampGroupIndex = Math.min(this.lampGroupIndex, groups.length - 1);
    }
    this.lampWallGrid.hidden = false;
    if (this.lampWallEmpty) this.lampWallEmpty.hidden = true;
    this.lampWallGrid.appendChild(this.createLampGroup(groups[this.lampGroupIndex]));
    this.setLampWallMeta(active, groups);
    this.scheduleLampRotation();
  };

  GardenController.prototype.changeLampGroup = function (direction) {
    var lights = this.activeLampLights();
    var groups = this.lampGroups(lights);
    var current;
    var incoming;
    var nextIndex;
    if (groups.length <= 1 || this.lampTransitionLocked || !this.lampWallGrid) return;
    nextIndex = (this.lampGroupIndex + direction + groups.length) % groups.length;
    current = this.lampWallGrid.querySelector('[data-qy-lamp-group]');
    incoming = this.createLampGroup(groups[nextIndex]);
    if (this.prefersReducedMotion() || !current) {
      this.lampGroupIndex = nextIndex;
      this.lampWallGrid.replaceChildren(incoming);
      this.setLampWallMeta(lights, groups);
      this.scheduleLampRotation();
      return;
    }
    this.clearLampRotation();
    this.lampTransitionLocked = true;
    current.classList.add(direction > 0 ? 'is-outgoing-next' : 'is-outgoing-previous');
    incoming.classList.add(direction > 0 ? 'is-incoming-next' : 'is-incoming-previous');
    incoming.setAttribute('aria-hidden', 'true');
    this.lampWallGrid.appendChild(incoming);
    void incoming.offsetWidth;
    this.lampWallGrid.classList.add('is-animating');
    this.lampTransitionTimer = global.setTimeout(function () {
      current.remove();
      incoming.classList.remove('is-incoming-next', 'is-incoming-previous');
      incoming.removeAttribute('aria-hidden');
      this.lampWallGrid.classList.remove('is-animating');
      this.lampGroupIndex = nextIndex;
      this.lampTransitionLocked = false;
      this.lampTransitionTimer = null;
      this.setLampWallMeta(lights, groups);
      this.scheduleLampRotation();
    }.bind(this), LAMP_TRANSITION_DURATION);
  };

  GardenController.prototype.renderLampWall = function (lights, scene) {
    if (this.liveLampModule) {
      this.renderLiveLampWall(lights, scene, false);
      return;
    }
    var self = this;
    var sceneConfig = this.sceneConfig(scene) || {};

    if (this.activeScene !== scene || !this.lampWallGrid) return;
    this.lampWallGrid.replaceChildren();
    if (this.lampWallTitle) {
      this.lampWallTitle.textContent = 'Lights in ' + (cleanString(sceneConfig.title) || 'this hall');
    }
    if (this.lampWallCount) {
      this.lampWallCount.textContent =
        lights.length
          ? lights.length + (lights.length === 1 ? ' light glowing now' : ' lights glowing now')
          : 'The hall is open for remembrance.';
    }
    if (this.lampWallStatus) {
      this.lampWallStatus.textContent = lights.length
        ? 'Each light remains visible only for its active dedication period.'
        : 'The hall is open for remembrance.';
    }

    lights.forEach(function (light) {
      var card = global.document.createElement('article');
      var flame = global.document.createElement('span');
      var name = global.document.createElement('strong');
      var time = global.document.createElement('span');

      card.className = 'qcg-lamp-wall-card';
      card.setAttribute('role', 'listitem');
      flame.className = 'qcg-lamp-wall-flame';
      flame.setAttribute('aria-hidden', 'true');
      name.textContent = cleanString(light.display_name) || 'Anonymous';
      time.textContent = self.formatLampTime(light.expires_at);
      card.appendChild(flame);
      card.appendChild(name);
      card.appendChild(time);
      self.lampWallGrid.appendChild(card);
    });
  };

  GardenController.prototype.loadLampWall = function (scene) {
    var requestId;
    var hallCode;

    if (!this.lampWall || !global.fetch || !isHall(scene)) return;
    if (this.lampWallAbort) this.lampWallAbort.abort();
    this.lampWallAbort = typeof global.AbortController === 'function' ? new global.AbortController() : null;
    requestId = ++this.lampWallRequest;
    hallCode = hallCodeForScene(scene);
    this.clearLampRotation();
    this.lampLights = [];
    if (this.lampWallGrid) {
      this.lampWallGrid.hidden = false;
      this.lampWallGrid.replaceChildren();
      this.lampWallGrid.setAttribute('aria-busy', 'true');
    }
    if (this.lampWallEmpty) this.lampWallEmpty.hidden = true;
    if (this.lampWallCount) this.lampWallCount.textContent = 'Gathering lights…';
    if (this.lampWallStatus) this.lampWallStatus.textContent = 'Gathering this hall\'s lights…';

    global
      .fetch('/apps/qiyuan-lights/lights?hall_code=' + encodeURIComponent(hallCode), {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
        cache: 'no-store',
        signal: this.lampWallAbort ? this.lampWallAbort.signal : undefined,
      })
      .then(function (response) {
        if (!response.ok) throw new Error('lamp_wall_unavailable');
        return response.json();
      })
      .then(
        function (payload) {
          var lights = Array.isArray(payload)
            ? payload
            : payload && Array.isArray(payload.lights)
              ? payload.lights
              : [];
          if (requestId !== this.lampWallRequest) return;
          this.renderLampWall(lights, scene);
        }.bind(this)
      )
      .catch(
        function () {
          if (requestId !== this.lampWallRequest || this.activeScene !== scene) return;
          if (this.lampWallAbort && this.lampWallAbort.signal.aborted) return;
          if (this.lampWallGrid) this.lampWallGrid.replaceChildren();
          if (this.lampWallGrid) this.lampWallGrid.setAttribute('aria-busy', 'false');
          if (this.lampWallCount) this.lampWallCount.textContent = 'Lights temporarily unavailable';
          if (this.lampWallEmpty) this.lampWallEmpty.hidden = false;
          if (this.lampWallStatus) {
            this.lampWallStatus.textContent =
              'The lights in this hall cannot be gathered right now. Please try again shortly.';
          }
        }.bind(this)
      );
  };

  GardenController.prototype.scrollToScene = function (focusHeading) {
    var self = this;
    if (!focusHeading) return;

    if (this.sceneTitle) this.sceneTitle.focus({ preventScroll: true });
    if (!this.stage || !this.stage.scrollIntoView) return;

    global.requestAnimationFrame(function () {
      self.stage.scrollIntoView({
        behavior: self.prefersReducedMotion() ? 'auto' : 'smooth',
        block: 'start',
      });
    });
  };

  GardenController.prototype.enterHall = function (scene, focusHeading) {
    if (!isHall(scene)) return;
    this.leaveGardenSound();
    if (scene === 'pet') {
      this.beginPetEntry(focusHeading);
      return;
    }

    this.isNearViewport = true;
    this.entryButtons.forEach(function (button) {
      button.setAttribute(
        'aria-expanded',
        button.getAttribute('data-qy-enter-hall') === scene ? 'true' : 'false'
      );
    });
    if (this.returnButton) this.returnButton.hidden = false;
    if (this.entrances) this.entrances.hidden = true;
    if (this.gardenOverview) this.gardenOverview.hidden = true;
    this.clearGardenPreviewRotation();
    if (this.hallContent) this.hallContent.hidden = false;
    this.hidePreview();
    this.clearSubmitError();
    this.showScene(scene);
    this.updateHallContent(scene);
    this.scrollToScene(focusHeading);
    if (scene === 'dizang' && lampAnalytics()) {
      lampAnalytics().trackGardenView();
    }
  };

  GardenController.prototype.returnToGarden = function (focusHeading) {
    var leavingDizang = this.activeScene === 'dizang';
    this.lampWallRequest += 1;
    if (this.lampWallAbort) this.lampWallAbort.abort();
    this.lampWallAbort = null;
    this.clearLampRotation();
    this.resetPetLamp({ resumeRotation: false });
    this.cancelPetEntry();
    this.entryButtons.forEach(function (button) {
      button.setAttribute('aria-expanded', 'false');
    });
    if (this.returnButton) this.returnButton.hidden = true;
    if (this.entrances) this.entrances.hidden = false;
    if (this.gardenOverview) this.gardenOverview.hidden = false;
    if (this.hallContent) this.hallContent.hidden = true;
    this.hidePreview();
    this.clearSubmitError();
    if (leavingDizang && lampAnalytics()) {
      lampAnalytics().resetFormLifecycle(this.dedicationForm);
    }
    this.showScene('garden');
    this.scheduleGardenPreviewRotation();
    this.scrollToScene(focusHeading);
  };

  GardenController.prototype.selectAction = function (action, userInitiated) {
    if (['lamp', 'incense', 'message'].indexOf(action) === -1) return;
    if (
      userInitiated &&
      this.activeScene === 'pet' &&
      (this.petLampBusy || this.petLampLit)
    ) {
      this.resetPetLamp({ resumeRotation: true });
    }
    if (this.activeScene === 'pet' && action === 'incense') action = 'lamp';
    if (!this.actionAvailable(action) && !this.showUnavailableOfferings) {
      action = ['lamp', 'message', 'incense'].find(
        function (candidate) {
          return this.actionAvailable(candidate);
        }.bind(this)
      ) || 'lamp';
    }

    this.activeAction = action;
    this.actionButtons.forEach(function (button) {
      var selected = button.getAttribute('data-qy-action') === action;
      button.classList.toggle('is-selected', selected);
      button.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });

    this.syncDurationOptions();
    this.updateSelectionStatus();
    if (userInitiated) {
      this.hidePreview();
      this.clearSubmitError();
    }
  };

  GardenController.prototype.updateSelectionStatus = function () {
    var priceNode = this.root.querySelector('[data-qy-selection-price]');
    var noteNode = this.root.querySelector('[data-qy-mapping-note]');
    var offering = getOffering(
      this.config,
      this.activeScene,
      this.activeAction,
      this.duration
    );

    this.currentOffering = offering;
    var durationCopy = this.duration === '1-day' ? '24 Hours' : offering.durationLabel;
    var liveValues = {
      '[data-qy-hero-duration]': durationCopy,
      '[data-qy-hero-price]': offering.price,
      '[data-qy-offer-duration]': durationCopy,
      '[data-qy-offer-price]': offering.price,
      '[data-qy-form-duration]': offering.durationLabel,
      '[data-qy-form-price]': offering.price,
      '[data-qy-preview-duration]': offering.durationLabel,
      '[data-qy-preview-price]': offering.price,
    };
    Object.keys(liveValues).forEach(function (selector) {
      var node = this.root.querySelector(selector);
      if (node) node.textContent = liveValues[selector];
    }, this);
    var heroButton = this.root.querySelector('[data-qy-scroll-to-lamp-form]');
    if (heroButton) heroButton.textContent = 'Light a Lamp — ' + offering.price;
    if (this.previewButton) this.previewButton.textContent = 'Preview My Light — ' + offering.price;
    if (this.confirmButton) this.confirmButton.textContent = 'Continue to Secure Checkout — ' + offering.price;
    if (!priceNode || !noteNode) return;

    if (offering.kind === 'paid') {
      priceNode.textContent =
        offering.label + ' · ' + offering.durationLabel + ' · ' + offering.price;
      noteNode.textContent = isPreviewOnlyScene(this.activeScene)
        ? 'Preview only. Nothing will be added to your cart.'
        : 'Continue through Shopify checkout.';
    } else {
      priceNode.textContent = 'Not yet available';
      noteNode.textContent = 'Please choose another dedication option.';
    }
  };

  GardenController.prototype.selection = function () {
    var offering = getOffering(
      this.config,
      this.activeScene,
      this.activeAction,
      this.duration
    );
    var sceneConfig = this.sceneConfig(this.activeScene) || {};

    if (this.liveLampModule) {
      var selectedPrivacy = this.root.querySelector('[data-qy-privacy]:checked');
      return {
        hall: cleanString(sceneConfig.title),
        hallCode: hallCodeForScene(this.activeScene),
        dedicationType: 'Light a Lamp',
        duration: offering.durationLabel,
        names: cleanString(this.namesField && this.namesField.value),
        privacy: cleanString(selectedPrivacy && selectedPrivacy.value),
        message: cleanString(this.messageField && this.messageField.value),
        offering: offering,
      };
    }

    return {
      hall: cleanString(sceneConfig.title),
      hallCode: hallCodeForScene(this.activeScene),
      dedicationType: offering.label,
      duration: offering.durationLabel,
      names: cleanString(this.namesField && this.namesField.value),
      recipient: cleanString(this.recipientField && this.recipientField.value),
      privacy: cleanString(this.privacyField && this.privacyField.value),
      email: cleanString(this.emailField && this.emailField.value),
      message: cleanString(this.messageField && this.messageField.value),
      newsletterConsent: Boolean(this.newsletterConsent && this.newsletterConsent.checked),
      offering: offering,
    };
  };

  GardenController.prototype.validateFields = function () {
    if (this.liveLampModule) {
      var selectedPrivacy = this.root.querySelector('[data-qy-privacy]:checked');
      var names = cleanString(this.namesField && this.namesField.value);
      var message = cleanString(this.messageField && this.messageField.value);
      var unsafe = /[<>]|(?:https?:\/\/|www\.|javascript\s*:|data\s*:)/i;
      if (this.namesField) {
        this.namesField.setCustomValidity(
          !names
            ? 'Please enter at least one name.'
            : names.length > 120 || unsafe.test(names)
              ? 'Please use 120 characters or fewer, without HTML or links.'
              : ''
        );
      }
      if (this.messageField) {
        this.messageField.setCustomValidity(
          message.length > 300 || unsafe.test(message)
            ? 'Please use 300 characters or fewer, without HTML or links.'
            : ''
        );
      }
      if (!selectedPrivacy) {
        this.showSubmitError('Please choose how this light should be displayed.');
        var firstPrivacy = this.privacyOptions[0];
        if (firstPrivacy) firstPrivacy.focus();
        return false;
      }
      var lampInvalid = [this.namesField, this.messageField].find(function (field) {
        return field && !field.checkValidity();
      });
      if (lampInvalid) {
        lampInvalid.reportValidity();
        lampInvalid.focus();
        return false;
      }
      return true;
    }
    var fields = [
      this.namesField,
      this.recipientField,
      this.privacyField,
      this.emailField,
      this.messageField,
    ];
    if (this.namesField) {
      this.namesField.setCustomValidity(
        cleanString(this.namesField.value) ? '' : 'Please enter at least one name.'
      );
    }
    if (this.messageField) {
      this.messageField.setCustomValidity(
        cleanString(this.messageField.value) ? '' : 'Please enter a wish or remembrance message.'
      );
    }
    if (this.recipientField) {
      this.recipientField.setCustomValidity(
        cleanString(this.recipientField.value) ? '' : 'Please enter the dedication recipient.'
      );
    }
    var invalid = fields.find(function (field) {
      return field && !field.checkValidity();
    });

    if (invalid) {
      invalid.reportValidity();
      invalid.focus();
      return false;
    }

    return true;
  };

  GardenController.prototype.fillPreview = function (selection) {
    if (this.liveLampModule) {
      var privacyTitle = selection.privacy === 'anonymous'
        ? 'ANONYMOUS PREVIEW'
        : selection.privacy === 'private_link_only'
          ? 'PRIVATE LINK-ONLY PREVIEW'
          : 'PUBLIC GARDEN PREVIEW';
      var displayName = selection.privacy === 'anonymous' ? 'Anonymous' : selection.names;
      var privacyCopy = selection.privacy === 'private_link_only'
        ? 'Visible only through your private result link; never shown on the public wall.'
        : selection.privacy === 'anonymous'
          ? 'The public wall displays Anonymous; your entered names remain private.'
          : 'Your entered name will appear on this hall\'s public lamp wall.';
      queryAll(this.root, '[data-qy-preview-title]').forEach(function (node) {
        node.textContent = privacyTitle;
      });
      var previewValues = {
        '[data-qy-preview-names]': displayName,
        '[data-qy-preview-message]': selection.message || 'A quiet light of remembrance.',
        '[data-qy-preview-offer]': 'A ' + selection.duration + ' light · ' + selection.offering.price,
        '[data-qy-preview-privacy]': privacyCopy,
      };
      Object.keys(previewValues).forEach(function (selector) {
        var node = this.root.querySelector(selector);
        if (node) node.textContent = previewValues[selector];
      }, this);
      var countdown = this.root.querySelector('[data-qy-preview-countdown]');
      if (countdown) countdown.textContent = this.formatLampDuration(durationSeconds(this.duration));
      if (this.previewPlaceholder) this.previewPlaceholder.hidden = true;
      if (this.previewContent) this.previewContent.hidden = false;
      if (this.confirmButton) {
        this.confirmButton.disabled = selection.offering.kind === 'unavailable';
        this.confirmButton.textContent = 'Continue to Secure Checkout — ' + selection.offering.price;
      }
      return;
    }
    var flow;
    var values = {
      '[data-qy-preview-hall]': selection.hall,
      '[data-qy-preview-type]': selection.dedicationType,
      '[data-qy-preview-duration]': selection.duration,
      '[data-qy-preview-names]': selection.names,
      '[data-qy-preview-recipient]': selection.recipient,
      '[data-qy-preview-privacy]': selection.privacy,
      '[data-qy-preview-email]': selection.email,
      '[data-qy-preview-message]': selection.message,
      '[data-qy-preview-consent]': selection.newsletterConsent ? 'Yes' : 'No',
    };

    if (isPreviewOnlyScene(this.activeScene)) {
      flow = 'Preview only. Nothing will be submitted, added to your cart, or sent to checkout.';
    } else if (selection.offering.kind === 'paid') {
      flow =
        selection.offering.price +
        ' through Shopify checkout. Order and payment status are created by Shopify.';
    } else {
      flow = 'This dedication option is not currently available.';
    }
    values['[data-qy-preview-flow]'] = flow;

    Object.keys(values).forEach(
      function (selector) {
        var node = this.root.querySelector(selector);
        if (node) node.textContent = values[selector];
      }.bind(this)
    );

    if (this.confirmButton) {
      this.confirmButton.hidden = isPreviewOnlyScene(this.activeScene);
      this.confirmButton.disabled =
        isPreviewOnlyScene(this.activeScene) || selection.offering.kind === 'unavailable';
      if (!isPreviewOnlyScene(this.activeScene)) {
        this.confirmButton.textContent =
          selection.offering.kind === 'paid' ? 'Continue to Payment' : 'Not yet available';
      }
    }
  };

  GardenController.prototype.preview = function () {
    var selection;
    var previewReady;

    this.clearSubmitError();
    if (!this.validateFields()) return;

    selection = this.selection();
    this.fillPreview(selection);
    if (this.previewPanel) {
      this.previewPanel.hidden = false;
      this.previewPanel.focus({ preventScroll: true });
      this.previewPanel.scrollIntoView({ behavior: this.prefersReducedMotion() ? 'auto' : 'smooth', block: 'nearest' });
    }
    previewReady = this.liveLampModule
      ? Boolean(this.previewContent && this.previewContent.hidden === false)
      : Boolean(this.previewPanel && this.previewPanel.hidden === false);
    if (this.activeScene === 'dizang' && previewReady && lampAnalytics()) {
      lampAnalytics().trackFormComplete(this.dedicationForm, {
        preview_ready: true,
        duration_code: durationCodeForSelection(this.duration),
      });
    }
  };

  GardenController.prototype.hidePreview = function () {
    if (this.liveLampModule) {
      if (this.previewPlaceholder) this.previewPlaceholder.hidden = false;
      if (this.previewContent) this.previewContent.hidden = true;
      queryAll(this.root, '[data-qy-preview-title]').forEach(function (node) {
        node.textContent = 'YOUR LIGHT PREVIEW';
      });
      return;
    }
    if (this.previewPanel) this.previewPanel.hidden = true;
  };

  GardenController.prototype.formatLampDuration = function (seconds) {
    var days = Math.floor(seconds / 86400);
    var hours = Math.floor((seconds % 86400) / 3600);
    var minutes = Math.floor((seconds % 3600) / 60);
    if (days) return days + 'd ' + String(hours).padStart(2, '0') + 'h ' + String(minutes).padStart(2, '0') + 'm';
    return String(hours).padStart(2, '0') + 'h ' + String(minutes).padStart(2, '0') + 'm 00s';
  };

  GardenController.prototype.clearSubmitError = function () {
    if (!this.submitError) return;
    this.submitError.hidden = true;
    this.submitError.textContent = '';
  };

  GardenController.prototype.showSubmitError = function (message) {
    if (!this.submitError) return;
    this.submitError.textContent =
      cleanString(message) ||
      'Something went wrong. Your selection was not submitted. Please try again.';
    this.submitError.hidden = false;
    this.submitError.focus({ preventScroll: true });
  };

  GardenController.prototype.prefersReducedMotion = function () {
    return Boolean(this.motionQuery && this.motionQuery.matches);
  };

  GardenController.prototype.submitNewsletterIfConsented = function (selection) {
    var email;
    var formData;

    if (!selection.newsletterConsent) return Promise.resolve();
    if (!this.newsletterForm || !global.fetch) {
      return Promise.reject(new Error('The Shopify newsletter form is unavailable.'));
    }

    email = this.newsletterForm.querySelector('[data-qy-newsletter-email]');
    if (email) email.value = selection.email;
    formData = new global.FormData(this.newsletterForm);

    return global
      .fetch(this.newsletterForm.action, {
        method: (this.newsletterForm.method || 'post').toUpperCase(),
        body: formData,
        credentials: 'same-origin',
        headers: {
          Accept: 'text/html',
        },
      })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Qiyuan Letters signup could not be confirmed.');
        }
        return response.text().then(function (html) {
          var responseUrl = response.url ? new global.URL(response.url, global.location.href) : null;
          var confirmedByUrl =
            responseUrl && responseUrl.searchParams.get('customer_posted') === 'true';
          var confirmedByMarkup = html.indexOf('data-qy-newsletter-success') !== -1;

          if (!confirmedByUrl && !confirmedByMarkup) {
            throw new Error(
              'Qiyuan Letters signup could not be confirmed. Your dedication was not submitted.'
            );
          }
          return { confirmed: true };
        });
      });
  };

  GardenController.prototype.submitPaidDedication = function (selection) {
    var durationCode = durationCodeForSelection(
      selection && selection.offering ? selection.offering.duration : ''
    );
    var nonce = randomProxyNonce();
    var payload = {
      program_code: 'guanyin_1d',
      duration_code: durationCode,
      hall_code: selection.hallCode,
      privacy: selection.privacy,
      names: selection.names,
      message: selection.message,
    };

    if (!global.fetch || !nonce || !durationCode) {
      return Promise.reject(new Error('Shopify checkout is unavailable in this browser.'));
    }

    return this.submitNewsletterIfConsented(selection)
      .then(
        function () {
          return global.fetch('/apps/qiyuan-lights/checkouts?nonce=' + nonce, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
          });
        }.bind(this)
      )
      .then(function (response) {
        if (response.ok) return response.json();
        return response
          .json()
          .catch(function () {
            return {};
          })
          .then(function (error) {
            throw new Error(
              cleanString(error.description || error.message) ||
                'Shopify could not prepare this dedication checkout.'
            );
          });
      })
      .then(function (result) {
        var checkoutUrl = cleanString(result && result.cart_permalink);
        if (!checkoutUrl) throw new Error('Shopify did not return a checkout link.');
        if (
          selection.hallCode === 'dizang' &&
          isCheckoutDestination(checkoutUrl) &&
          lampAnalytics()
        ) {
          lampAnalytics().trackBeginCheckout(this.dedicationForm, {
            checkout_ready: true,
            currency: this.config && this.config.currency,
            value: analyticsPriceValue(selection.offering && selection.offering.price),
            item_id: selection.offering && selection.offering.variantId,
            duration_code: durationCode,
          });
        }
        global.location.assign(checkoutUrl);
      }.bind(this));
  };

  GardenController.prototype.confirm = function () {
    var selection;
    if (isPreviewOnlyScene(this.activeScene)) return;
    if (this.submitting || !this.validateFields()) return;
    selection = this.selection();
    this.fillPreview(selection);

    if (selection.offering.kind === 'unavailable') {
      this.showSubmitError('This dedication option is not currently available.');
      return;
    }

    this.submitting = true;
    this.clearSubmitError();
    if (this.confirmButton) {
      this.confirmButton.disabled = true;
      this.confirmButton.textContent = 'Opening Shopify checkout…';
    }

    Promise.resolve(this.submitPaidDedication(selection)).catch(
      function (error) {
        this.submitting = false;
        this.fillPreview(selection);
        this.showSubmitError(error && error.message);
      }.bind(this)
    );
  };

  GardenController.prototype.handleClick = function (event) {
    var target = event.target;
    var entryButton = target.closest && target.closest('[data-qy-enter-hall]');
    var overviewEntry = target.closest && target.closest('[data-qy-overview-enter-hall]');
    var actionButton = target.closest && target.closest('[data-qy-action]');

    if (target.closest && target.closest('[data-qy-sound-toggle]')) {
      this.toggleGardenSound();
      return;
    }

    if (target.closest && target.closest('[data-qy-scroll-to-lamp-form]')) {
      if (this.lampFormSection) this.lampFormSection.scrollIntoView({
        behavior: this.prefersReducedMotion() ? 'auto' : 'smooth',
        block: 'start',
      });
      if (this.namesField) this.namesField.focus({ preventScroll: true });
      return;
    }
    if (target.closest && target.closest('[data-qy-lamp-wall-previous]')) {
      this.changeLampGroup(-1);
      return;
    }
    if (target.closest && target.closest('[data-qy-lamp-wall-next]')) {
      this.changeLampGroup(1);
      return;
    }

    if (target.closest && target.closest('[data-qy-pet-transition-retry]')) {
      this.retryPetEntry();
      return;
    }
    if (target.closest && target.closest('[data-qy-pet-transition-return]')) {
      this.returnToGarden(true);
      return;
    }
    if (target.closest && target.closest('[data-qy-loader-retry]')) {
      this.retryModel();
      return;
    }
    if (target.closest && target.closest('[data-qy-loader-return]')) {
      this.returnToGarden(true);
      return;
    }
    if (target.closest && target.closest('[data-qy-download-remembrance-card]')) {
      this.downloadRemembranceCard();
      return;
    }
    if (target.closest && target.closest('[data-qy-light-another-lamp]')) {
      this.hidePreview();
      this.resetPetLamp({
        clearFields: true,
        focusNames: true,
        resumeRotation: true,
      });
      return;
    }
    if (overviewEntry && this.root.contains(overviewEntry)) {
      if (this.petEntryInProgress) return;
      this.enterHall(overviewEntry.getAttribute('data-qy-overview-enter-hall'), true);
      return;
    }
    if (entryButton && this.root.contains(entryButton)) {
      if (this.petEntryInProgress) return;
      this.enterHall(entryButton.getAttribute('data-qy-enter-hall'), true);
      return;
    }
    if (target.closest && target.closest('[data-qy-return]')) {
      this.returnToGarden(true);
      return;
    }
    if (actionButton && this.root.contains(actionButton)) {
      this.selectAction(actionButton.getAttribute('data-qy-action'), true);
      return;
    }
    if (target.closest && target.closest('[data-qy-preview]')) {
      this.preview();
      return;
    }
    if (target.closest && target.closest('[data-qy-edit]')) {
      this.hidePreview();
      if (this.activeScene === 'pet' && (this.petLampBusy || this.petLampLit)) {
        this.resetPetLamp({ resumeRotation: true });
      }
      if (this.namesField) this.namesField.focus();
      return;
    }
    if (target.closest && target.closest('[data-qy-confirm]')) {
      this.confirm();
    }
  };

  GardenController.prototype.handleFormSubmit = function (event) {
    event.preventDefault();
    this.preview();
  };

  GardenController.prototype.handleInput = function (event) {
    var analyticsDuration = this.duration;
    var isKnownLampField =
      this.durationOptions.indexOf(event.target) !== -1 ||
      this.privacyOptions.indexOf(event.target) !== -1 ||
      event.target === this.namesField ||
      event.target === this.messageField;
    var isChoice = /^(?:checkbox|radio|select-one|select-multiple)$/i.test(
      cleanString(event.target && event.target.type)
    );
    var isMeaningful = isChoice || Boolean(cleanString(event.target && event.target.value));
    var hasUserActivation =
      !global.navigator ||
      !global.navigator.userActivation ||
      global.navigator.userActivation.isActive === true;
    if (this.durationOptions.indexOf(event.target) !== -1 && isDuration(event.target.value)) {
      analyticsDuration = event.target.value;
    }
    if (
      this.activeScene === 'dizang' &&
      event.isTrusted === true &&
      hasUserActivation &&
      /^(?:input|change)$/.test(event.type) &&
      isKnownLampField &&
      isMeaningful &&
      lampAnalytics()
    ) {
      lampAnalytics().trackFormStart(this.dedicationForm, {
        duration_code: durationCodeForSelection(analyticsDuration),
      });
    }

    if (this.durationOptions.indexOf(event.target) !== -1) {
      this.durationField = event.target;
      this.duration = isDuration(event.target.value)
        ? event.target.value
        : '1-day';
      this.updateSelectionStatus();
    }

    if (this.privacyOptions.indexOf(event.target) !== -1) this.privacyField = event.target;

    if (
      this.durationOptions.indexOf(event.target) !== -1 ||
      event.target === this.namesField ||
      event.target === this.recipientField ||
      this.privacyOptions.indexOf(event.target) !== -1 ||
      event.target === this.emailField ||
      event.target === this.messageField ||
      event.target === this.newsletterConsent
    ) {
      if (this.activeScene === 'pet' && (this.petLampBusy || this.petLampLit)) {
        this.resetPetLamp({ resumeRotation: true });
      }
      if (
        (event.target === this.namesField ||
          event.target === this.recipientField ||
          event.target === this.messageField) &&
        event.target.setCustomValidity
      ) {
        event.target.setCustomValidity('');
      }
      this.hidePreview();
      this.clearSubmitError();
    }
    if (this.namesCount && event.target === this.namesField) {
      this.namesCount.textContent = Array.from(this.namesField.value).length + ' / 120';
    }
    if (this.messageCount && event.target === this.messageField) {
      this.messageCount.textContent = Array.from(this.messageField.value).length + ' / 300';
    }
  };

  GardenController.prototype.handleLampVisibility = function () {
    if (global.document.hidden) {
      this.clearLampRotation();
      this.clearGardenPreviewRotation();
    } else {
      this.scheduleLampRotation();
      this.scheduleGardenPreviewRotation();
    }
  };

  GardenController.prototype.handleLampResize = function () {
    if (!isHall(this.activeScene) || !this.lampLights.length) return;
    this.renderLiveLampWall(this.lampLights, this.activeScene, true);
  };

  GardenController.prototype.updateLampCountdowns = function () {
    var before = this.lampLights.length;
    var active = this.activeLampLights();
    queryAll(this.root, '[data-qy-lamp-expires]').forEach(function (node) {
      node.textContent = this.formatLampTime(node.getAttribute('data-qy-lamp-expires'));
    }, this);
    queryAll(this.root, '[data-qy-garden-lamp-expires]').forEach(function (node) {
      node.textContent = this.formatLampTime(node.getAttribute('data-qy-garden-lamp-expires'));
    }, this);
    HALLS.forEach(function (scene) {
      var state = this.gardenPublicState[scene];
      if (state && state.status === 'success' && state.activeCount !== this.activeGardenLights(scene).length) {
        this.renderGardenPublicState(scene);
        this.scheduleGardenPreviewRotation();
      }
    }, this);
    if (active.length !== before && isHall(this.activeScene)) {
      this.lampLights = active;
      this.renderLiveLampWall(active, this.activeScene, true);
    }
  };

  GardenController.prototype.handleModelReady = function () {
    var event = arguments[0];
    var slot =
      (event && event.detail && event.detail.kind) ||
      (this.viewer && this.viewer.getAttribute('data-model-kind')) ||
      this.pendingSlot;
    var scene = this.slotScenes[slot] || this.pendingScene;
    var requestedScene = this.pendingScene;

    this.currentSlot = slot;
    this.loadedScene = scene;
    if (requestedScene && scene !== requestedScene && this.activeScene === requestedScene) {
      this.configureModel(requestedScene);
      return;
    }

    if (scene === requestedScene) {
      this.pendingScene = '';
      this.pendingSlot = '';
    }
    if (scene === this.activeScene) {
      if (this.modelView) this.modelView.hidden = false;
      if (this.viewerControls) this.viewerControls.hidden = false;
      this.setMediaAccessibility('ready');
      this.setFallbackMessage('', false);
      this.finishModelLoading(scene);
      this.resumeViewer();
      if (scene === 'pet' && this.petEntryInProgress) {
        this.completePetEntry();
      }
    } else if (this.modelUrl(this.activeScene)) {
      this.configureModel(this.activeScene);
    }
  };

  GardenController.prototype.handleMotionChange = function () {
    if (this.prefersReducedMotion()) {
      this.clearLampRotation();
      this.clearGardenPreviewRotation();
      this.pauseViewer(false);
      this.wasAutoRotating = false;
      if (this.petTransitionTimer) {
        global.clearTimeout(this.petTransitionTimer);
        this.petTransitionTimer = null;
        this.startPetModelLoad();
      }
      if (this.petRevealTimer) {
        global.clearTimeout(this.petRevealTimer);
        this.petRevealTimer = null;
        this.revealPetHall();
      }
      if (this.petLampBusy) {
        this.clearPetLampTimers();
        if (this.petLampLayer) this.petLampLayer.setAttribute('data-state', 'lighting');
        this.revealPetLamp();
      }
    } else {
      this.scheduleLampRotation();
      this.scheduleGardenPreviewRotation();
    }
  };

  GardenController.prototype.handleIntersection = function (entries) {
    var entry = entries && entries[0];
    if (!entry) return;

    this.isNearViewport = entry.isIntersecting;
    if (entry.isIntersecting) {
      if (this.modelUrl(this.activeScene)) {
        if (this.modelView) this.modelView.hidden = false;
        this.configureModel(this.activeScene);
      } else {
        this.resumeViewer();
      }
    } else {
      this.pauseViewer(true);
    }
  };

  GardenController.prototype.normalizeViewerState = function () {
    var hasError;
    var statusText;
    var progressMatch;

    if (!this.viewer) return;
    statusText = cleanString(this.viewerStatus && this.viewerStatus.textContent);
    progressMatch = statusText.match(/(\d{1,3})\s*%/);
    if (progressMatch) {
      this.setLoaderProgress(Number(progressMatch[1]));
    }
    if (
      this.viewerStatus &&
      /Loading 3D model|Preparing the garden|\d{1,3}\s*%/i.test(statusText) &&
      statusText !== 'Preparing the garden…'
    ) {
      this.viewerStatus.textContent = 'Preparing the garden…';
    }

    hasError =
      this.viewer.classList.contains('q3d-has-error') ||
      Boolean(this.viewerStatus && this.viewerStatus.classList.contains('is-error'));

    if (hasError && this.activeScene === this.pendingScene) {
      this.showModelError(this.activeScene);
    }
  };

  GardenController.prototype.connect = function () {
    var queryHall;
    var success;

    if (this.connected) return;
    this.connected = true;
    this.root.addEventListener('click', this.handleClick);
    this.root.addEventListener('input', this.handleInput);
    this.root.addEventListener('change', this.handleInput);
    if (this.dedicationForm) {
      this.dedicationForm.addEventListener('submit', this.handleFormSubmit);
    }
    if (this.soundAudio) {
      this.soundAudio.volume = 0;
      this.soundAudio.pause();
      this.soundAudio.addEventListener('timeupdate', this.handleSoundTimeUpdate);
      this.soundAudio.addEventListener('loadedmetadata', this.handleSoundMetadata);
    }
    if (this.viewer) this.viewer.addEventListener('qiyuan:model-ready', this.handleModelReady);
    global.document.addEventListener('visibilitychange', this.handleLampVisibility);
    global.addEventListener('resize', this.handleLampResize);
    if (this.lampWallFrame) {
      this.lampWallFrame.addEventListener('mouseenter', this.handleLampEnter);
      this.lampWallFrame.addEventListener('mouseleave', this.handleLampLeave);
      this.lampWallFrame.addEventListener('focusin', this.handleLampFocusIn);
      this.lampWallFrame.addEventListener('focusout', this.handleLampFocusOut);
    }
    this.lampCountdownTimer = global.setInterval(function () {
      this.updateLampCountdowns();
    }.bind(this), 1000);

    if (this.motionQuery) {
      if (this.motionQuery.addEventListener) {
        this.motionQuery.addEventListener('change', this.handleMotionChange);
      } else if (this.motionQuery.addListener) {
        this.motionQuery.addListener(this.handleMotionChange);
      }
    }

    if (global.IntersectionObserver) {
      this.intersectionObserver = new global.IntersectionObserver(this.handleIntersection, {
        rootMargin: '160px 0px',
        threshold: 0.01,
      });
      this.intersectionObserver.observe(this.root);
    }
    if (this.viewer && global.MutationObserver) {
      this.viewerObserver = new global.MutationObserver(
        this.normalizeViewerState.bind(this)
      );
      this.viewerObserver.observe(this.viewer, {
        attributes: true,
        attributeFilter: ['class', 'data-model-kind'],
        childList: true,
        characterData: true,
        subtree: true,
      });
    }

    if (this.durationField && isDuration(this.durationField.value)) {
      this.duration = this.durationField.value;
    }
    this.selectAction('lamp', false);
    this.showScene('garden');
    this.syncGardenSoundControl();
    this.loadGardenOverview();

    if (global.location && global.URLSearchParams) {
      queryHall = new global.URLSearchParams(global.location.search).get('qy_garden');
      if (queryHall === 'pet_memorial') queryHall = 'pet';
      if (isHall(queryHall)) this.enterHall(queryHall, false);
    }

    success = this.root.querySelector('[data-qy-contact-success]');
    if (success) {
      success.focus({ preventScroll: true });
      success.scrollIntoView({
        behavior: this.prefersReducedMotion() ? 'auto' : 'smooth',
        block: 'center',
      });
    }
  };

  GardenController.prototype.disconnect = function () {
    if (!this.connected) return;
    this.connected = false;
    this.clearLoaderTimers();
    this.resetPetLamp({ resumeRotation: false });
    this.cancelPetEntry();
    this.root.removeEventListener('click', this.handleClick);
    this.root.removeEventListener('input', this.handleInput);
    this.root.removeEventListener('change', this.handleInput);
    this.cancelGardenSoundFade();
    if (this.soundAudio) {
      this.saveGardenSoundTime();
      this.soundAudio.removeEventListener('timeupdate', this.handleSoundTimeUpdate);
      this.soundAudio.removeEventListener('loadedmetadata', this.handleSoundMetadata);
      this.soundAudio.pause();
      this.soundAudio.volume = 0;
    }
    global.document.removeEventListener('visibilitychange', this.handleLampVisibility);
    global.removeEventListener('resize', this.handleLampResize);
    if (this.lampWallFrame) {
      this.lampWallFrame.removeEventListener('mouseenter', this.handleLampEnter);
      this.lampWallFrame.removeEventListener('mouseleave', this.handleLampLeave);
      this.lampWallFrame.removeEventListener('focusin', this.handleLampFocusIn);
      this.lampWallFrame.removeEventListener('focusout', this.handleLampFocusOut);
    }
    this.clearLampRotation();
    this.clearGardenPreviewRotation();
    if (this.lampTransitionTimer) global.clearTimeout(this.lampTransitionTimer);
    if (this.lampCountdownTimer) global.clearInterval(this.lampCountdownTimer);
    this.lampTransitionTimer = null;
    this.lampCountdownTimer = null;
    if (this.lampWallAbort) this.lampWallAbort.abort();
    this.lampWallAbort = null;
    if (this.gardenOverviewAbort) this.gardenOverviewAbort.abort();
    this.gardenOverviewAbort = null;
    if (this.dedicationForm) {
      this.dedicationForm.removeEventListener('submit', this.handleFormSubmit);
    }
    if (this.viewer) this.viewer.removeEventListener('qiyuan:model-ready', this.handleModelReady);

    if (this.motionQuery) {
      if (this.motionQuery.removeEventListener) {
        this.motionQuery.removeEventListener('change', this.handleMotionChange);
      } else if (this.motionQuery.removeListener) {
        this.motionQuery.removeListener(this.handleMotionChange);
      }
    }
    if (this.intersectionObserver) {
      this.intersectionObserver.disconnect();
      this.intersectionObserver = null;
    }
    if (this.viewerObserver) {
      this.viewerObserver.disconnect();
      this.viewerObserver = null;
    }
  };

  function initializeRoot(root) {
    var controller = getController(root);

    if (controller) return controller;
    restoreParkedViewer(root);
    controller = new GardenController(root);
    setController(root, controller);
    controller.connect();
    return controller;
  }

  function init(scope) {
    if (!global.document) return [];
    return rootsWithin(scope || global.document).map(initializeRoot);
  }

  function destroy(scope) {
    rootsWithin(scope || global.document).forEach(function (root) {
      var controller = getController(root);
      if (controller) controller.disconnect();
      removeController(root);
    });
  }

  var api = {
    version: '2.5.0',
    init: init,
    destroy: destroy,
    isHall: isHall,
    isPreviewOnlyScene: isPreviewOnlyScene,
    hallCodeForScene: hallCodeForScene,
    durationCodeForSelection: durationCodeForSelection,
    durationSeconds: durationSeconds,
    lampCapacityForWidth: lampCapacityForWidth,
    groupLampLights: groupLampLights,
    activePublicLights: activePublicLights,
    publicLampName: publicLampName,
    gardenPreviewLights: gardenPreviewLights,
    clampSoundVolume: clampSoundVolume,
    gardenSoundTargetVolume: GARDEN_SOUND_TARGET_VOLUME,
    gardenSoundFadeInDuration: GARDEN_SOUND_FADE_IN_DURATION,
    gardenSoundFadeOutDuration: GARDEN_SOUND_FADE_OUT_DURATION,
    entryTransitionDelay: entryTransitionDelay,
    petLampRevealDelay: petLampRevealDelay,
    formatPetLampResult: formatPetLampResult,
    buildRemembranceCardSvg: buildRemembranceCardSvg,
    getOffering: getOffering,
    buildLineItemProperties: buildLineItemProperties,
    buildCartPayload: buildCartPayload,
    source: SOURCE,
  };

  global.QiyuanEasternMemorialGarden = api;
  global.Qiyuan3DCoreEntrances = api;

  if (global.document && global.document.addEventListener) {
    global.document.addEventListener('shopify:section:unload', function (event) {
      parkViewers(event.target);
    });

    global.document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });

    if (global.document.readyState === 'loading') {
      global.document.addEventListener(
        'DOMContentLoaded',
        function () {
          init(global.document);
        },
        { once: true }
      );
    } else {
      init(global.document);
    }
  }
})(typeof window !== 'undefined' ? window : globalThis);
